// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/DriveModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { StringValue } from "../../../google/protobuf/wrappers";

export const protobufPackage = "daisi.protos.v1";

export enum DriveFileStatus {
  DriveFileStatusActive = 0,
  DriveFileStatusArchived = 1,
  DriveFileStatusUploading = 2,
  DriveFileStatusProcessing = 3,
  DriveFileStatusDegraded = 4,
  DriveFileStatusTrashed = 5,
  UNRECOGNIZED = -1,
}

export function driveFileStatusFromJSON(object: any): DriveFileStatus {
  switch (object) {
    case 0:
    case "DriveFileStatusActive":
      return DriveFileStatus.DriveFileStatusActive;
    case 1:
    case "DriveFileStatusArchived":
      return DriveFileStatus.DriveFileStatusArchived;
    case 2:
    case "DriveFileStatusUploading":
      return DriveFileStatus.DriveFileStatusUploading;
    case 3:
    case "DriveFileStatusProcessing":
      return DriveFileStatus.DriveFileStatusProcessing;
    case 4:
    case "DriveFileStatusDegraded":
      return DriveFileStatus.DriveFileStatusDegraded;
    case 5:
    case "DriveFileStatusTrashed":
      return DriveFileStatus.DriveFileStatusTrashed;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DriveFileStatus.UNRECOGNIZED;
  }
}

export function driveFileStatusToJSON(object: DriveFileStatus): string {
  switch (object) {
    case DriveFileStatus.DriveFileStatusActive:
      return "DriveFileStatusActive";
    case DriveFileStatus.DriveFileStatusArchived:
      return "DriveFileStatusArchived";
    case DriveFileStatus.DriveFileStatusUploading:
      return "DriveFileStatusUploading";
    case DriveFileStatus.DriveFileStatusProcessing:
      return "DriveFileStatusProcessing";
    case DriveFileStatus.DriveFileStatusDegraded:
      return "DriveFileStatusDegraded";
    case DriveFileStatus.DriveFileStatusTrashed:
      return "DriveFileStatusTrashed";
    case DriveFileStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RepositoryType {
  RepositoryTypeAccount = 0,
  RepositoryTypeTrash = 1,
  RepositoryTypePrivate = 2,
  RepositoryTypeCustom = 3,
  UNRECOGNIZED = -1,
}

export function repositoryTypeFromJSON(object: any): RepositoryType {
  switch (object) {
    case 0:
    case "RepositoryTypeAccount":
      return RepositoryType.RepositoryTypeAccount;
    case 1:
    case "RepositoryTypeTrash":
      return RepositoryType.RepositoryTypeTrash;
    case 2:
    case "RepositoryTypePrivate":
      return RepositoryType.RepositoryTypePrivate;
    case 3:
    case "RepositoryTypeCustom":
      return RepositoryType.RepositoryTypeCustom;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RepositoryType.UNRECOGNIZED;
  }
}

export function repositoryTypeToJSON(object: RepositoryType): string {
  switch (object) {
    case RepositoryType.RepositoryTypeAccount:
      return "RepositoryTypeAccount";
    case RepositoryType.RepositoryTypeTrash:
      return "RepositoryTypeTrash";
    case RepositoryType.RepositoryTypePrivate:
      return "RepositoryTypePrivate";
    case RepositoryType.RepositoryTypeCustom:
      return "RepositoryTypeCustom";
    case RepositoryType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface DriveFile {
  Id: string;
  AccountId: string;
  Name: string;
  Path: string;
  SizeBytes: Long;
  ContentType: string;
  Sha256Hash: string;
  DateCreated?: Date | undefined;
  DateModified?: Date | undefined;
  IsSystemFile: boolean;
  Status: DriveFileStatus;
  Description?: string | undefined;
  Tags: string[];
  ErasureConfig?: ErasureCodingConfig | undefined;
  RepositoryId: string;
  FolderId: string;
  CreatedByUserId: string;
  CreatedByUserName: string;
  TrashInfo?: TrashEntry | undefined;
}

export interface DriveRepository {
  Id: string;
  AccountId: string;
  Name: string;
  Type: RepositoryType;
  CreatedByUserId: string;
  CreatedByUserName: string;
  DateCreated?: Date | undefined;
  DateModified?: Date | undefined;
  TotalSizeBytes: Long;
  FileCount: number;
  AccessList: RepositoryAccess[];
  RestrictFolderCreationToManagers: boolean;
}

export interface RepositoryAccess {
  UserId: string;
  UserName: string;
  IsApp: boolean;
  GrantedByUserId: string;
  DateGranted?: Date | undefined;
}

export interface DriveFolderRecord {
  Id: string;
  AccountId: string;
  RepositoryId: string;
  Name: string;
  ParentFolderId: string;
  FullPath: string;
  CreatedByUserId: string;
  CreatedByUserName: string;
  DateCreated?: Date | undefined;
  DateModified?: Date | undefined;
  FileCount: number;
  TotalSizeBytes: Long;
}

export interface TrashEntry {
  OriginalRepositoryId: string;
  OriginalRepositoryName: string;
  OriginalFolderId: string;
  OriginalPath: string;
  DateTrashed?: Date | undefined;
  TrashedByUserId: string;
}

export interface DriveFolder {
  Path: string;
  Name: string;
  FileCount: number;
  TotalSizeBytes: Long;
}

export interface ErasureCodingConfig {
  DataShards: number;
  ParityShards: number;
}

export interface ShardInfo {
  ShardId: string;
  FileId: string;
  ShardIndex: number;
  HostId: string;
  SizeBytes: Long;
  IsParity: boolean;
}

export interface StorageLimits {
  MaxFileSizeBytes: Long;
  MaxTotalStorageBytes: Long;
  UsedStorageBytes: Long;
  MaxFileCount: number;
  DefaultErasureConfig?: ErasureCodingConfig | undefined;
}

export interface VectorSearchResult {
  FileId: string;
  FileName: string;
  Snippet: string;
  Score: number;
  ChunkIndex: number;
}

export interface FileChunk {
  Data: Uint8Array;
  Offset: Long;
  TotalSize: Long;
  FileName?: string | undefined;
  ContentType?: string | undefined;
  Path?: string | undefined;
  IsSystemFile: boolean;
  RepositoryId?: string | undefined;
  FolderId?: string | undefined;
}

export interface ShardChunk {
  Data: Uint8Array;
  ShardId: string;
  ShardIndex: number;
  Offset: Long;
  TotalSize: Long;
}

export interface UploadResponse {
  Success: boolean;
  File?: DriveFile | undefined;
  Error?: string | undefined;
}

export interface DownloadRequest {
  FileId: string;
}

export interface ListFilesRequest {
  Path?: string | undefined;
  SearchQuery?: string | undefined;
  IncludeSystemFiles: boolean;
  PageSize: number;
  ContinuationToken?: string | undefined;
  RepositoryId?: string | undefined;
  FolderId?: string | undefined;
}

export interface ListFilesResponse {
  Files: DriveFile[];
  Folders: DriveFolder[];
  ContinuationToken?: string | undefined;
  Limits?: StorageLimits | undefined;
  SubFolders: DriveFolderRecord[];
  Repository?: DriveRepository | undefined;
}

export interface DeleteFileRequest {
  FileId: string;
}

export interface DeleteFileResponse {
  Success: boolean;
}

export interface VectorSearchRequest {
  Query: string;
  TopK: number;
  IncludeSystemFiles: boolean;
  FileIds: string[];
  RepositoryIds: string[];
}

export interface VectorSearchResponse {
  Results: VectorSearchResult[];
}

export interface FileSearchRequest {
  Query: string;
  MaxResults: number;
  RepositoryIds: string[];
}

export interface FileSearchResponse {
  Files: DriveFile[];
}

/** Repository management */
export interface CreateRepositoryRequest {
  Name: string;
}

export interface CreateRepositoryResponse {
  Success: boolean;
  Repository?: DriveRepository | undefined;
  Error?: string | undefined;
}

export interface ListRepositoriesRequest {
  IncludeTrash: boolean;
}

export interface ListRepositoriesResponse {
  Repositories: DriveRepository[];
}

export interface DeleteRepositoryRequest {
  RepositoryId: string;
}

export interface DeleteRepositoryResponse {
  Success: boolean;
  Error?: string | undefined;
}

export interface GrantRepositoryAccessRequest {
  RepositoryId: string;
  UserId: string;
  UserName: string;
  IsApp: boolean;
}

export interface GrantRepositoryAccessResponse {
  Success: boolean;
  Error?: string | undefined;
}

export interface RevokeRepositoryAccessRequest {
  RepositoryId: string;
  UserId: string;
}

export interface RevokeRepositoryAccessResponse {
  Success: boolean;
  Error?: string | undefined;
}

/** Folder management */
export interface CreateFolderRequest {
  RepositoryId: string;
  Name: string;
  ParentFolderId?: string | undefined;
}

export interface CreateFolderResponse {
  Success: boolean;
  Folder?: DriveFolderRecord | undefined;
  Error?: string | undefined;
}

export interface DeleteFolderRequest {
  FolderId: string;
}

export interface DeleteFolderResponse {
  Success: boolean;
  Error?: string | undefined;
}

/** File operations */
export interface MoveFileRequest {
  FileId: string;
  TargetRepositoryId: string;
  TargetFolderId?: string | undefined;
}

export interface MoveFileResponse {
  Success: boolean;
  Error?: string | undefined;
}

/** Trash operations */
export interface ListTrashRequest {
  PageSize: number;
}

export interface ListTrashResponse {
  Files: DriveFile[];
}

export interface RestoreFromTrashRequest {
  FileId: string;
}

export interface RestoreFromTrashResponse {
  Success: boolean;
  Error?: string | undefined;
}

export interface EmptyTrashRequest {
}

export interface EmptyTrashResponse {
  Success: boolean;
  DeletedCount: number;
}

/** File preview */
export interface GetFilePreviewRequest {
  FileId: string;
}

export interface GetFilePreviewResponse {
  PreviewHtml: string;
  PreviewContentType: string;
  RawBytes: Uint8Array;
}

/** Account drive settings */
export interface GetAccountDriveSettingsRequest {
}

export interface GetAccountDriveSettingsResponse {
  RestrictFolderCreationToManagers: boolean;
}

export interface SetAccountDriveSettingsRequest {
  RestrictFolderCreationToManagers: boolean;
}

export interface SetAccountDriveSettingsResponse {
  Success: boolean;
}

function createBaseDriveFile(): DriveFile {
  return {
    Id: "",
    AccountId: "",
    Name: "",
    Path: "",
    SizeBytes: Long.ZERO,
    ContentType: "",
    Sha256Hash: "",
    DateCreated: undefined,
    DateModified: undefined,
    IsSystemFile: false,
    Status: 0,
    Description: undefined,
    Tags: [],
    ErasureConfig: undefined,
    RepositoryId: "",
    FolderId: "",
    CreatedByUserId: "",
    CreatedByUserName: "",
    TrashInfo: undefined,
  };
}

export const DriveFile: MessageFns<DriveFile> = {
  encode(message: DriveFile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.AccountId !== "") {
      writer.uint32(18).string(message.AccountId);
    }
    if (message.Name !== "") {
      writer.uint32(26).string(message.Name);
    }
    if (message.Path !== "") {
      writer.uint32(34).string(message.Path);
    }
    if (!message.SizeBytes.equals(Long.ZERO)) {
      writer.uint32(40).int64(message.SizeBytes.toString());
    }
    if (message.ContentType !== "") {
      writer.uint32(50).string(message.ContentType);
    }
    if (message.Sha256Hash !== "") {
      writer.uint32(58).string(message.Sha256Hash);
    }
    if (message.DateCreated !== undefined) {
      Timestamp.encode(toTimestamp(message.DateCreated), writer.uint32(66).fork()).join();
    }
    if (message.DateModified !== undefined) {
      Timestamp.encode(toTimestamp(message.DateModified), writer.uint32(74).fork()).join();
    }
    if (message.IsSystemFile !== false) {
      writer.uint32(80).bool(message.IsSystemFile);
    }
    if (message.Status !== 0) {
      writer.uint32(88).int32(message.Status);
    }
    if (message.Description !== undefined) {
      StringValue.encode({ value: message.Description! }, writer.uint32(98).fork()).join();
    }
    for (const v of message.Tags) {
      writer.uint32(106).string(v!);
    }
    if (message.ErasureConfig !== undefined) {
      ErasureCodingConfig.encode(message.ErasureConfig, writer.uint32(114).fork()).join();
    }
    if (message.RepositoryId !== "") {
      writer.uint32(122).string(message.RepositoryId);
    }
    if (message.FolderId !== "") {
      writer.uint32(130).string(message.FolderId);
    }
    if (message.CreatedByUserId !== "") {
      writer.uint32(138).string(message.CreatedByUserId);
    }
    if (message.CreatedByUserName !== "") {
      writer.uint32(146).string(message.CreatedByUserName);
    }
    if (message.TrashInfo !== undefined) {
      TrashEntry.encode(message.TrashInfo, writer.uint32(154).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DriveFile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDriveFile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Path = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.SizeBytes = Long.fromString(reader.int64().toString());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ContentType = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.Sha256Hash = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.DateCreated = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.DateModified = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.IsSystemFile = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.Status = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.Description = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.Tags.push(reader.string());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.ErasureConfig = ErasureCodingConfig.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.RepositoryId = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.FolderId = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.CreatedByUserId = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.CreatedByUserName = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.TrashInfo = TrashEntry.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DriveFile {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Path: isSet(object.Path) ? globalThis.String(object.Path) : "",
      SizeBytes: isSet(object.SizeBytes) ? Long.fromValue(object.SizeBytes) : Long.ZERO,
      ContentType: isSet(object.ContentType) ? globalThis.String(object.ContentType) : "",
      Sha256Hash: isSet(object.Sha256Hash) ? globalThis.String(object.Sha256Hash) : "",
      DateCreated: isSet(object.DateCreated) ? fromJsonTimestamp(object.DateCreated) : undefined,
      DateModified: isSet(object.DateModified) ? fromJsonTimestamp(object.DateModified) : undefined,
      IsSystemFile: isSet(object.IsSystemFile) ? globalThis.Boolean(object.IsSystemFile) : false,
      Status: isSet(object.Status) ? driveFileStatusFromJSON(object.Status) : 0,
      Description: isSet(object.Description) ? String(object.Description) : undefined,
      Tags: globalThis.Array.isArray(object?.Tags) ? object.Tags.map((e: any) => globalThis.String(e)) : [],
      ErasureConfig: isSet(object.ErasureConfig) ? ErasureCodingConfig.fromJSON(object.ErasureConfig) : undefined,
      RepositoryId: isSet(object.RepositoryId) ? globalThis.String(object.RepositoryId) : "",
      FolderId: isSet(object.FolderId) ? globalThis.String(object.FolderId) : "",
      CreatedByUserId: isSet(object.CreatedByUserId) ? globalThis.String(object.CreatedByUserId) : "",
      CreatedByUserName: isSet(object.CreatedByUserName) ? globalThis.String(object.CreatedByUserName) : "",
      TrashInfo: isSet(object.TrashInfo) ? TrashEntry.fromJSON(object.TrashInfo) : undefined,
    };
  },

  toJSON(message: DriveFile): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Path !== "") {
      obj.Path = message.Path;
    }
    if (!message.SizeBytes.equals(Long.ZERO)) {
      obj.SizeBytes = (message.SizeBytes || Long.ZERO).toString();
    }
    if (message.ContentType !== "") {
      obj.ContentType = message.ContentType;
    }
    if (message.Sha256Hash !== "") {
      obj.Sha256Hash = message.Sha256Hash;
    }
    if (message.DateCreated !== undefined) {
      obj.DateCreated = message.DateCreated.toISOString();
    }
    if (message.DateModified !== undefined) {
      obj.DateModified = message.DateModified.toISOString();
    }
    if (message.IsSystemFile !== false) {
      obj.IsSystemFile = message.IsSystemFile;
    }
    if (message.Status !== 0) {
      obj.Status = driveFileStatusToJSON(message.Status);
    }
    if (message.Description !== undefined) {
      obj.Description = message.Description;
    }
    if (message.Tags?.length) {
      obj.Tags = message.Tags;
    }
    if (message.ErasureConfig !== undefined) {
      obj.ErasureConfig = ErasureCodingConfig.toJSON(message.ErasureConfig);
    }
    if (message.RepositoryId !== "") {
      obj.RepositoryId = message.RepositoryId;
    }
    if (message.FolderId !== "") {
      obj.FolderId = message.FolderId;
    }
    if (message.CreatedByUserId !== "") {
      obj.CreatedByUserId = message.CreatedByUserId;
    }
    if (message.CreatedByUserName !== "") {
      obj.CreatedByUserName = message.CreatedByUserName;
    }
    if (message.TrashInfo !== undefined) {
      obj.TrashInfo = TrashEntry.toJSON(message.TrashInfo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DriveFile>, I>>(base?: I): DriveFile {
    return DriveFile.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DriveFile>, I>>(object: I): DriveFile {
    const message = createBaseDriveFile();
    message.Id = object.Id ?? "";
    message.AccountId = object.AccountId ?? "";
    message.Name = object.Name ?? "";
    message.Path = object.Path ?? "";
    message.SizeBytes = (object.SizeBytes !== undefined && object.SizeBytes !== null)
      ? Long.fromValue(object.SizeBytes)
      : Long.ZERO;
    message.ContentType = object.ContentType ?? "";
    message.Sha256Hash = object.Sha256Hash ?? "";
    message.DateCreated = object.DateCreated ?? undefined;
    message.DateModified = object.DateModified ?? undefined;
    message.IsSystemFile = object.IsSystemFile ?? false;
    message.Status = object.Status ?? 0;
    message.Description = object.Description ?? undefined;
    message.Tags = object.Tags?.map((e) => e) || [];
    message.ErasureConfig = (object.ErasureConfig !== undefined && object.ErasureConfig !== null)
      ? ErasureCodingConfig.fromPartial(object.ErasureConfig)
      : undefined;
    message.RepositoryId = object.RepositoryId ?? "";
    message.FolderId = object.FolderId ?? "";
    message.CreatedByUserId = object.CreatedByUserId ?? "";
    message.CreatedByUserName = object.CreatedByUserName ?? "";
    message.TrashInfo = (object.TrashInfo !== undefined && object.TrashInfo !== null)
      ? TrashEntry.fromPartial(object.TrashInfo)
      : undefined;
    return message;
  },
};

function createBaseDriveRepository(): DriveRepository {
  return {
    Id: "",
    AccountId: "",
    Name: "",
    Type: 0,
    CreatedByUserId: "",
    CreatedByUserName: "",
    DateCreated: undefined,
    DateModified: undefined,
    TotalSizeBytes: Long.ZERO,
    FileCount: 0,
    AccessList: [],
    RestrictFolderCreationToManagers: false,
  };
}

export const DriveRepository: MessageFns<DriveRepository> = {
  encode(message: DriveRepository, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.AccountId !== "") {
      writer.uint32(18).string(message.AccountId);
    }
    if (message.Name !== "") {
      writer.uint32(26).string(message.Name);
    }
    if (message.Type !== 0) {
      writer.uint32(32).int32(message.Type);
    }
    if (message.CreatedByUserId !== "") {
      writer.uint32(42).string(message.CreatedByUserId);
    }
    if (message.CreatedByUserName !== "") {
      writer.uint32(50).string(message.CreatedByUserName);
    }
    if (message.DateCreated !== undefined) {
      Timestamp.encode(toTimestamp(message.DateCreated), writer.uint32(58).fork()).join();
    }
    if (message.DateModified !== undefined) {
      Timestamp.encode(toTimestamp(message.DateModified), writer.uint32(66).fork()).join();
    }
    if (!message.TotalSizeBytes.equals(Long.ZERO)) {
      writer.uint32(72).int64(message.TotalSizeBytes.toString());
    }
    if (message.FileCount !== 0) {
      writer.uint32(80).int32(message.FileCount);
    }
    for (const v of message.AccessList) {
      RepositoryAccess.encode(v!, writer.uint32(90).fork()).join();
    }
    if (message.RestrictFolderCreationToManagers !== false) {
      writer.uint32(96).bool(message.RestrictFolderCreationToManagers);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DriveRepository {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDriveRepository();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.Type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.CreatedByUserId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.CreatedByUserName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.DateCreated = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.DateModified = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.TotalSizeBytes = Long.fromString(reader.int64().toString());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.FileCount = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.AccessList.push(RepositoryAccess.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.RestrictFolderCreationToManagers = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DriveRepository {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Type: isSet(object.Type) ? repositoryTypeFromJSON(object.Type) : 0,
      CreatedByUserId: isSet(object.CreatedByUserId) ? globalThis.String(object.CreatedByUserId) : "",
      CreatedByUserName: isSet(object.CreatedByUserName) ? globalThis.String(object.CreatedByUserName) : "",
      DateCreated: isSet(object.DateCreated) ? fromJsonTimestamp(object.DateCreated) : undefined,
      DateModified: isSet(object.DateModified) ? fromJsonTimestamp(object.DateModified) : undefined,
      TotalSizeBytes: isSet(object.TotalSizeBytes) ? Long.fromValue(object.TotalSizeBytes) : Long.ZERO,
      FileCount: isSet(object.FileCount) ? globalThis.Number(object.FileCount) : 0,
      AccessList: globalThis.Array.isArray(object?.AccessList)
        ? object.AccessList.map((e: any) => RepositoryAccess.fromJSON(e))
        : [],
      RestrictFolderCreationToManagers: isSet(object.RestrictFolderCreationToManagers)
        ? globalThis.Boolean(object.RestrictFolderCreationToManagers)
        : false,
    };
  },

  toJSON(message: DriveRepository): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Type !== 0) {
      obj.Type = repositoryTypeToJSON(message.Type);
    }
    if (message.CreatedByUserId !== "") {
      obj.CreatedByUserId = message.CreatedByUserId;
    }
    if (message.CreatedByUserName !== "") {
      obj.CreatedByUserName = message.CreatedByUserName;
    }
    if (message.DateCreated !== undefined) {
      obj.DateCreated = message.DateCreated.toISOString();
    }
    if (message.DateModified !== undefined) {
      obj.DateModified = message.DateModified.toISOString();
    }
    if (!message.TotalSizeBytes.equals(Long.ZERO)) {
      obj.TotalSizeBytes = (message.TotalSizeBytes || Long.ZERO).toString();
    }
    if (message.FileCount !== 0) {
      obj.FileCount = Math.round(message.FileCount);
    }
    if (message.AccessList?.length) {
      obj.AccessList = message.AccessList.map((e) => RepositoryAccess.toJSON(e));
    }
    if (message.RestrictFolderCreationToManagers !== false) {
      obj.RestrictFolderCreationToManagers = message.RestrictFolderCreationToManagers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DriveRepository>, I>>(base?: I): DriveRepository {
    return DriveRepository.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DriveRepository>, I>>(object: I): DriveRepository {
    const message = createBaseDriveRepository();
    message.Id = object.Id ?? "";
    message.AccountId = object.AccountId ?? "";
    message.Name = object.Name ?? "";
    message.Type = object.Type ?? 0;
    message.CreatedByUserId = object.CreatedByUserId ?? "";
    message.CreatedByUserName = object.CreatedByUserName ?? "";
    message.DateCreated = object.DateCreated ?? undefined;
    message.DateModified = object.DateModified ?? undefined;
    message.TotalSizeBytes = (object.TotalSizeBytes !== undefined && object.TotalSizeBytes !== null)
      ? Long.fromValue(object.TotalSizeBytes)
      : Long.ZERO;
    message.FileCount = object.FileCount ?? 0;
    message.AccessList = object.AccessList?.map((e) => RepositoryAccess.fromPartial(e)) || [];
    message.RestrictFolderCreationToManagers = object.RestrictFolderCreationToManagers ?? false;
    return message;
  },
};

function createBaseRepositoryAccess(): RepositoryAccess {
  return { UserId: "", UserName: "", IsApp: false, GrantedByUserId: "", DateGranted: undefined };
}

export const RepositoryAccess: MessageFns<RepositoryAccess> = {
  encode(message: RepositoryAccess, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.UserId !== "") {
      writer.uint32(10).string(message.UserId);
    }
    if (message.UserName !== "") {
      writer.uint32(18).string(message.UserName);
    }
    if (message.IsApp !== false) {
      writer.uint32(24).bool(message.IsApp);
    }
    if (message.GrantedByUserId !== "") {
      writer.uint32(34).string(message.GrantedByUserId);
    }
    if (message.DateGranted !== undefined) {
      Timestamp.encode(toTimestamp(message.DateGranted), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepositoryAccess {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepositoryAccess();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.UserId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.UserName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.IsApp = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.GrantedByUserId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.DateGranted = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepositoryAccess {
    return {
      UserId: isSet(object.UserId) ? globalThis.String(object.UserId) : "",
      UserName: isSet(object.UserName) ? globalThis.String(object.UserName) : "",
      IsApp: isSet(object.IsApp) ? globalThis.Boolean(object.IsApp) : false,
      GrantedByUserId: isSet(object.GrantedByUserId) ? globalThis.String(object.GrantedByUserId) : "",
      DateGranted: isSet(object.DateGranted) ? fromJsonTimestamp(object.DateGranted) : undefined,
    };
  },

  toJSON(message: RepositoryAccess): unknown {
    const obj: any = {};
    if (message.UserId !== "") {
      obj.UserId = message.UserId;
    }
    if (message.UserName !== "") {
      obj.UserName = message.UserName;
    }
    if (message.IsApp !== false) {
      obj.IsApp = message.IsApp;
    }
    if (message.GrantedByUserId !== "") {
      obj.GrantedByUserId = message.GrantedByUserId;
    }
    if (message.DateGranted !== undefined) {
      obj.DateGranted = message.DateGranted.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RepositoryAccess>, I>>(base?: I): RepositoryAccess {
    return RepositoryAccess.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RepositoryAccess>, I>>(object: I): RepositoryAccess {
    const message = createBaseRepositoryAccess();
    message.UserId = object.UserId ?? "";
    message.UserName = object.UserName ?? "";
    message.IsApp = object.IsApp ?? false;
    message.GrantedByUserId = object.GrantedByUserId ?? "";
    message.DateGranted = object.DateGranted ?? undefined;
    return message;
  },
};

function createBaseDriveFolderRecord(): DriveFolderRecord {
  return {
    Id: "",
    AccountId: "",
    RepositoryId: "",
    Name: "",
    ParentFolderId: "",
    FullPath: "",
    CreatedByUserId: "",
    CreatedByUserName: "",
    DateCreated: undefined,
    DateModified: undefined,
    FileCount: 0,
    TotalSizeBytes: Long.ZERO,
  };
}

export const DriveFolderRecord: MessageFns<DriveFolderRecord> = {
  encode(message: DriveFolderRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.AccountId !== "") {
      writer.uint32(18).string(message.AccountId);
    }
    if (message.RepositoryId !== "") {
      writer.uint32(26).string(message.RepositoryId);
    }
    if (message.Name !== "") {
      writer.uint32(34).string(message.Name);
    }
    if (message.ParentFolderId !== "") {
      writer.uint32(42).string(message.ParentFolderId);
    }
    if (message.FullPath !== "") {
      writer.uint32(50).string(message.FullPath);
    }
    if (message.CreatedByUserId !== "") {
      writer.uint32(58).string(message.CreatedByUserId);
    }
    if (message.CreatedByUserName !== "") {
      writer.uint32(66).string(message.CreatedByUserName);
    }
    if (message.DateCreated !== undefined) {
      Timestamp.encode(toTimestamp(message.DateCreated), writer.uint32(74).fork()).join();
    }
    if (message.DateModified !== undefined) {
      Timestamp.encode(toTimestamp(message.DateModified), writer.uint32(82).fork()).join();
    }
    if (message.FileCount !== 0) {
      writer.uint32(88).int32(message.FileCount);
    }
    if (!message.TotalSizeBytes.equals(Long.ZERO)) {
      writer.uint32(96).int64(message.TotalSizeBytes.toString());
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DriveFolderRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDriveFolderRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.RepositoryId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ParentFolderId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.FullPath = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.CreatedByUserId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.CreatedByUserName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.DateCreated = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.DateModified = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.FileCount = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.TotalSizeBytes = Long.fromString(reader.int64().toString());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DriveFolderRecord {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      RepositoryId: isSet(object.RepositoryId) ? globalThis.String(object.RepositoryId) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      ParentFolderId: isSet(object.ParentFolderId) ? globalThis.String(object.ParentFolderId) : "",
      FullPath: isSet(object.FullPath) ? globalThis.String(object.FullPath) : "",
      CreatedByUserId: isSet(object.CreatedByUserId) ? globalThis.String(object.CreatedByUserId) : "",
      CreatedByUserName: isSet(object.CreatedByUserName) ? globalThis.String(object.CreatedByUserName) : "",
      DateCreated: isSet(object.DateCreated) ? fromJsonTimestamp(object.DateCreated) : undefined,
      DateModified: isSet(object.DateModified) ? fromJsonTimestamp(object.DateModified) : undefined,
      FileCount: isSet(object.FileCount) ? globalThis.Number(object.FileCount) : 0,
      TotalSizeBytes: isSet(object.TotalSizeBytes) ? Long.fromValue(object.TotalSizeBytes) : Long.ZERO,
    };
  },

  toJSON(message: DriveFolderRecord): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.RepositoryId !== "") {
      obj.RepositoryId = message.RepositoryId;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.ParentFolderId !== "") {
      obj.ParentFolderId = message.ParentFolderId;
    }
    if (message.FullPath !== "") {
      obj.FullPath = message.FullPath;
    }
    if (message.CreatedByUserId !== "") {
      obj.CreatedByUserId = message.CreatedByUserId;
    }
    if (message.CreatedByUserName !== "") {
      obj.CreatedByUserName = message.CreatedByUserName;
    }
    if (message.DateCreated !== undefined) {
      obj.DateCreated = message.DateCreated.toISOString();
    }
    if (message.DateModified !== undefined) {
      obj.DateModified = message.DateModified.toISOString();
    }
    if (message.FileCount !== 0) {
      obj.FileCount = Math.round(message.FileCount);
    }
    if (!message.TotalSizeBytes.equals(Long.ZERO)) {
      obj.TotalSizeBytes = (message.TotalSizeBytes || Long.ZERO).toString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DriveFolderRecord>, I>>(base?: I): DriveFolderRecord {
    return DriveFolderRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DriveFolderRecord>, I>>(object: I): DriveFolderRecord {
    const message = createBaseDriveFolderRecord();
    message.Id = object.Id ?? "";
    message.AccountId = object.AccountId ?? "";
    message.RepositoryId = object.RepositoryId ?? "";
    message.Name = object.Name ?? "";
    message.ParentFolderId = object.ParentFolderId ?? "";
    message.FullPath = object.FullPath ?? "";
    message.CreatedByUserId = object.CreatedByUserId ?? "";
    message.CreatedByUserName = object.CreatedByUserName ?? "";
    message.DateCreated = object.DateCreated ?? undefined;
    message.DateModified = object.DateModified ?? undefined;
    message.FileCount = object.FileCount ?? 0;
    message.TotalSizeBytes = (object.TotalSizeBytes !== undefined && object.TotalSizeBytes !== null)
      ? Long.fromValue(object.TotalSizeBytes)
      : Long.ZERO;
    return message;
  },
};

function createBaseTrashEntry(): TrashEntry {
  return {
    OriginalRepositoryId: "",
    OriginalRepositoryName: "",
    OriginalFolderId: "",
    OriginalPath: "",
    DateTrashed: undefined,
    TrashedByUserId: "",
  };
}

export const TrashEntry: MessageFns<TrashEntry> = {
  encode(message: TrashEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.OriginalRepositoryId !== "") {
      writer.uint32(10).string(message.OriginalRepositoryId);
    }
    if (message.OriginalRepositoryName !== "") {
      writer.uint32(18).string(message.OriginalRepositoryName);
    }
    if (message.OriginalFolderId !== "") {
      writer.uint32(26).string(message.OriginalFolderId);
    }
    if (message.OriginalPath !== "") {
      writer.uint32(34).string(message.OriginalPath);
    }
    if (message.DateTrashed !== undefined) {
      Timestamp.encode(toTimestamp(message.DateTrashed), writer.uint32(42).fork()).join();
    }
    if (message.TrashedByUserId !== "") {
      writer.uint32(50).string(message.TrashedByUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrashEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrashEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.OriginalRepositoryId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.OriginalRepositoryName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.OriginalFolderId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.OriginalPath = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.DateTrashed = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.TrashedByUserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrashEntry {
    return {
      OriginalRepositoryId: isSet(object.OriginalRepositoryId) ? globalThis.String(object.OriginalRepositoryId) : "",
      OriginalRepositoryName: isSet(object.OriginalRepositoryName)
        ? globalThis.String(object.OriginalRepositoryName)
        : "",
      OriginalFolderId: isSet(object.OriginalFolderId) ? globalThis.String(object.OriginalFolderId) : "",
      OriginalPath: isSet(object.OriginalPath) ? globalThis.String(object.OriginalPath) : "",
      DateTrashed: isSet(object.DateTrashed) ? fromJsonTimestamp(object.DateTrashed) : undefined,
      TrashedByUserId: isSet(object.TrashedByUserId) ? globalThis.String(object.TrashedByUserId) : "",
    };
  },

  toJSON(message: TrashEntry): unknown {
    const obj: any = {};
    if (message.OriginalRepositoryId !== "") {
      obj.OriginalRepositoryId = message.OriginalRepositoryId;
    }
    if (message.OriginalRepositoryName !== "") {
      obj.OriginalRepositoryName = message.OriginalRepositoryName;
    }
    if (message.OriginalFolderId !== "") {
      obj.OriginalFolderId = message.OriginalFolderId;
    }
    if (message.OriginalPath !== "") {
      obj.OriginalPath = message.OriginalPath;
    }
    if (message.DateTrashed !== undefined) {
      obj.DateTrashed = message.DateTrashed.toISOString();
    }
    if (message.TrashedByUserId !== "") {
      obj.TrashedByUserId = message.TrashedByUserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrashEntry>, I>>(base?: I): TrashEntry {
    return TrashEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrashEntry>, I>>(object: I): TrashEntry {
    const message = createBaseTrashEntry();
    message.OriginalRepositoryId = object.OriginalRepositoryId ?? "";
    message.OriginalRepositoryName = object.OriginalRepositoryName ?? "";
    message.OriginalFolderId = object.OriginalFolderId ?? "";
    message.OriginalPath = object.OriginalPath ?? "";
    message.DateTrashed = object.DateTrashed ?? undefined;
    message.TrashedByUserId = object.TrashedByUserId ?? "";
    return message;
  },
};

function createBaseDriveFolder(): DriveFolder {
  return { Path: "", Name: "", FileCount: 0, TotalSizeBytes: Long.ZERO };
}

export const DriveFolder: MessageFns<DriveFolder> = {
  encode(message: DriveFolder, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Path !== "") {
      writer.uint32(10).string(message.Path);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    if (message.FileCount !== 0) {
      writer.uint32(24).int32(message.FileCount);
    }
    if (!message.TotalSizeBytes.equals(Long.ZERO)) {
      writer.uint32(32).int64(message.TotalSizeBytes.toString());
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DriveFolder {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDriveFolder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Path = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.FileCount = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.TotalSizeBytes = Long.fromString(reader.int64().toString());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DriveFolder {
    return {
      Path: isSet(object.Path) ? globalThis.String(object.Path) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      FileCount: isSet(object.FileCount) ? globalThis.Number(object.FileCount) : 0,
      TotalSizeBytes: isSet(object.TotalSizeBytes) ? Long.fromValue(object.TotalSizeBytes) : Long.ZERO,
    };
  },

  toJSON(message: DriveFolder): unknown {
    const obj: any = {};
    if (message.Path !== "") {
      obj.Path = message.Path;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.FileCount !== 0) {
      obj.FileCount = Math.round(message.FileCount);
    }
    if (!message.TotalSizeBytes.equals(Long.ZERO)) {
      obj.TotalSizeBytes = (message.TotalSizeBytes || Long.ZERO).toString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DriveFolder>, I>>(base?: I): DriveFolder {
    return DriveFolder.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DriveFolder>, I>>(object: I): DriveFolder {
    const message = createBaseDriveFolder();
    message.Path = object.Path ?? "";
    message.Name = object.Name ?? "";
    message.FileCount = object.FileCount ?? 0;
    message.TotalSizeBytes = (object.TotalSizeBytes !== undefined && object.TotalSizeBytes !== null)
      ? Long.fromValue(object.TotalSizeBytes)
      : Long.ZERO;
    return message;
  },
};

function createBaseErasureCodingConfig(): ErasureCodingConfig {
  return { DataShards: 0, ParityShards: 0 };
}

export const ErasureCodingConfig: MessageFns<ErasureCodingConfig> = {
  encode(message: ErasureCodingConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.DataShards !== 0) {
      writer.uint32(8).int32(message.DataShards);
    }
    if (message.ParityShards !== 0) {
      writer.uint32(16).int32(message.ParityShards);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ErasureCodingConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseErasureCodingConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.DataShards = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.ParityShards = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ErasureCodingConfig {
    return {
      DataShards: isSet(object.DataShards) ? globalThis.Number(object.DataShards) : 0,
      ParityShards: isSet(object.ParityShards) ? globalThis.Number(object.ParityShards) : 0,
    };
  },

  toJSON(message: ErasureCodingConfig): unknown {
    const obj: any = {};
    if (message.DataShards !== 0) {
      obj.DataShards = Math.round(message.DataShards);
    }
    if (message.ParityShards !== 0) {
      obj.ParityShards = Math.round(message.ParityShards);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ErasureCodingConfig>, I>>(base?: I): ErasureCodingConfig {
    return ErasureCodingConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ErasureCodingConfig>, I>>(object: I): ErasureCodingConfig {
    const message = createBaseErasureCodingConfig();
    message.DataShards = object.DataShards ?? 0;
    message.ParityShards = object.ParityShards ?? 0;
    return message;
  },
};

function createBaseShardInfo(): ShardInfo {
  return { ShardId: "", FileId: "", ShardIndex: 0, HostId: "", SizeBytes: Long.ZERO, IsParity: false };
}

export const ShardInfo: MessageFns<ShardInfo> = {
  encode(message: ShardInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ShardId !== "") {
      writer.uint32(10).string(message.ShardId);
    }
    if (message.FileId !== "") {
      writer.uint32(18).string(message.FileId);
    }
    if (message.ShardIndex !== 0) {
      writer.uint32(24).int32(message.ShardIndex);
    }
    if (message.HostId !== "") {
      writer.uint32(34).string(message.HostId);
    }
    if (!message.SizeBytes.equals(Long.ZERO)) {
      writer.uint32(40).int64(message.SizeBytes.toString());
    }
    if (message.IsParity !== false) {
      writer.uint32(48).bool(message.IsParity);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ShardInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseShardInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ShardId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.FileId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.ShardIndex = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.HostId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.SizeBytes = Long.fromString(reader.int64().toString());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.IsParity = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ShardInfo {
    return {
      ShardId: isSet(object.ShardId) ? globalThis.String(object.ShardId) : "",
      FileId: isSet(object.FileId) ? globalThis.String(object.FileId) : "",
      ShardIndex: isSet(object.ShardIndex) ? globalThis.Number(object.ShardIndex) : 0,
      HostId: isSet(object.HostId) ? globalThis.String(object.HostId) : "",
      SizeBytes: isSet(object.SizeBytes) ? Long.fromValue(object.SizeBytes) : Long.ZERO,
      IsParity: isSet(object.IsParity) ? globalThis.Boolean(object.IsParity) : false,
    };
  },

  toJSON(message: ShardInfo): unknown {
    const obj: any = {};
    if (message.ShardId !== "") {
      obj.ShardId = message.ShardId;
    }
    if (message.FileId !== "") {
      obj.FileId = message.FileId;
    }
    if (message.ShardIndex !== 0) {
      obj.ShardIndex = Math.round(message.ShardIndex);
    }
    if (message.HostId !== "") {
      obj.HostId = message.HostId;
    }
    if (!message.SizeBytes.equals(Long.ZERO)) {
      obj.SizeBytes = (message.SizeBytes || Long.ZERO).toString();
    }
    if (message.IsParity !== false) {
      obj.IsParity = message.IsParity;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ShardInfo>, I>>(base?: I): ShardInfo {
    return ShardInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ShardInfo>, I>>(object: I): ShardInfo {
    const message = createBaseShardInfo();
    message.ShardId = object.ShardId ?? "";
    message.FileId = object.FileId ?? "";
    message.ShardIndex = object.ShardIndex ?? 0;
    message.HostId = object.HostId ?? "";
    message.SizeBytes = (object.SizeBytes !== undefined && object.SizeBytes !== null)
      ? Long.fromValue(object.SizeBytes)
      : Long.ZERO;
    message.IsParity = object.IsParity ?? false;
    return message;
  },
};

function createBaseStorageLimits(): StorageLimits {
  return {
    MaxFileSizeBytes: Long.ZERO,
    MaxTotalStorageBytes: Long.ZERO,
    UsedStorageBytes: Long.ZERO,
    MaxFileCount: 0,
    DefaultErasureConfig: undefined,
  };
}

export const StorageLimits: MessageFns<StorageLimits> = {
  encode(message: StorageLimits, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (!message.MaxFileSizeBytes.equals(Long.ZERO)) {
      writer.uint32(8).int64(message.MaxFileSizeBytes.toString());
    }
    if (!message.MaxTotalStorageBytes.equals(Long.ZERO)) {
      writer.uint32(16).int64(message.MaxTotalStorageBytes.toString());
    }
    if (!message.UsedStorageBytes.equals(Long.ZERO)) {
      writer.uint32(24).int64(message.UsedStorageBytes.toString());
    }
    if (message.MaxFileCount !== 0) {
      writer.uint32(32).int32(message.MaxFileCount);
    }
    if (message.DefaultErasureConfig !== undefined) {
      ErasureCodingConfig.encode(message.DefaultErasureConfig, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StorageLimits {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStorageLimits();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.MaxFileSizeBytes = Long.fromString(reader.int64().toString());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.MaxTotalStorageBytes = Long.fromString(reader.int64().toString());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.UsedStorageBytes = Long.fromString(reader.int64().toString());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.MaxFileCount = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.DefaultErasureConfig = ErasureCodingConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StorageLimits {
    return {
      MaxFileSizeBytes: isSet(object.MaxFileSizeBytes) ? Long.fromValue(object.MaxFileSizeBytes) : Long.ZERO,
      MaxTotalStorageBytes: isSet(object.MaxTotalStorageBytes)
        ? Long.fromValue(object.MaxTotalStorageBytes)
        : Long.ZERO,
      UsedStorageBytes: isSet(object.UsedStorageBytes) ? Long.fromValue(object.UsedStorageBytes) : Long.ZERO,
      MaxFileCount: isSet(object.MaxFileCount) ? globalThis.Number(object.MaxFileCount) : 0,
      DefaultErasureConfig: isSet(object.DefaultErasureConfig)
        ? ErasureCodingConfig.fromJSON(object.DefaultErasureConfig)
        : undefined,
    };
  },

  toJSON(message: StorageLimits): unknown {
    const obj: any = {};
    if (!message.MaxFileSizeBytes.equals(Long.ZERO)) {
      obj.MaxFileSizeBytes = (message.MaxFileSizeBytes || Long.ZERO).toString();
    }
    if (!message.MaxTotalStorageBytes.equals(Long.ZERO)) {
      obj.MaxTotalStorageBytes = (message.MaxTotalStorageBytes || Long.ZERO).toString();
    }
    if (!message.UsedStorageBytes.equals(Long.ZERO)) {
      obj.UsedStorageBytes = (message.UsedStorageBytes || Long.ZERO).toString();
    }
    if (message.MaxFileCount !== 0) {
      obj.MaxFileCount = Math.round(message.MaxFileCount);
    }
    if (message.DefaultErasureConfig !== undefined) {
      obj.DefaultErasureConfig = ErasureCodingConfig.toJSON(message.DefaultErasureConfig);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StorageLimits>, I>>(base?: I): StorageLimits {
    return StorageLimits.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StorageLimits>, I>>(object: I): StorageLimits {
    const message = createBaseStorageLimits();
    message.MaxFileSizeBytes = (object.MaxFileSizeBytes !== undefined && object.MaxFileSizeBytes !== null)
      ? Long.fromValue(object.MaxFileSizeBytes)
      : Long.ZERO;
    message.MaxTotalStorageBytes = (object.MaxTotalStorageBytes !== undefined && object.MaxTotalStorageBytes !== null)
      ? Long.fromValue(object.MaxTotalStorageBytes)
      : Long.ZERO;
    message.UsedStorageBytes = (object.UsedStorageBytes !== undefined && object.UsedStorageBytes !== null)
      ? Long.fromValue(object.UsedStorageBytes)
      : Long.ZERO;
    message.MaxFileCount = object.MaxFileCount ?? 0;
    message.DefaultErasureConfig = (object.DefaultErasureConfig !== undefined && object.DefaultErasureConfig !== null)
      ? ErasureCodingConfig.fromPartial(object.DefaultErasureConfig)
      : undefined;
    return message;
  },
};

function createBaseVectorSearchResult(): VectorSearchResult {
  return { FileId: "", FileName: "", Snippet: "", Score: 0, ChunkIndex: 0 };
}

export const VectorSearchResult: MessageFns<VectorSearchResult> = {
  encode(message: VectorSearchResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.FileId !== "") {
      writer.uint32(10).string(message.FileId);
    }
    if (message.FileName !== "") {
      writer.uint32(18).string(message.FileName);
    }
    if (message.Snippet !== "") {
      writer.uint32(26).string(message.Snippet);
    }
    if (message.Score !== 0) {
      writer.uint32(37).float(message.Score);
    }
    if (message.ChunkIndex !== 0) {
      writer.uint32(40).int32(message.ChunkIndex);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VectorSearchResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVectorSearchResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.FileId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.FileName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Snippet = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.Score = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.ChunkIndex = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VectorSearchResult {
    return {
      FileId: isSet(object.FileId) ? globalThis.String(object.FileId) : "",
      FileName: isSet(object.FileName) ? globalThis.String(object.FileName) : "",
      Snippet: isSet(object.Snippet) ? globalThis.String(object.Snippet) : "",
      Score: isSet(object.Score) ? globalThis.Number(object.Score) : 0,
      ChunkIndex: isSet(object.ChunkIndex) ? globalThis.Number(object.ChunkIndex) : 0,
    };
  },

  toJSON(message: VectorSearchResult): unknown {
    const obj: any = {};
    if (message.FileId !== "") {
      obj.FileId = message.FileId;
    }
    if (message.FileName !== "") {
      obj.FileName = message.FileName;
    }
    if (message.Snippet !== "") {
      obj.Snippet = message.Snippet;
    }
    if (message.Score !== 0) {
      obj.Score = message.Score;
    }
    if (message.ChunkIndex !== 0) {
      obj.ChunkIndex = Math.round(message.ChunkIndex);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VectorSearchResult>, I>>(base?: I): VectorSearchResult {
    return VectorSearchResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VectorSearchResult>, I>>(object: I): VectorSearchResult {
    const message = createBaseVectorSearchResult();
    message.FileId = object.FileId ?? "";
    message.FileName = object.FileName ?? "";
    message.Snippet = object.Snippet ?? "";
    message.Score = object.Score ?? 0;
    message.ChunkIndex = object.ChunkIndex ?? 0;
    return message;
  },
};

function createBaseFileChunk(): FileChunk {
  return {
    Data: new Uint8Array(0),
    Offset: Long.ZERO,
    TotalSize: Long.ZERO,
    FileName: undefined,
    ContentType: undefined,
    Path: undefined,
    IsSystemFile: false,
    RepositoryId: undefined,
    FolderId: undefined,
  };
}

export const FileChunk: MessageFns<FileChunk> = {
  encode(message: FileChunk, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Data.length !== 0) {
      writer.uint32(10).bytes(message.Data);
    }
    if (!message.Offset.equals(Long.ZERO)) {
      writer.uint32(16).int64(message.Offset.toString());
    }
    if (!message.TotalSize.equals(Long.ZERO)) {
      writer.uint32(24).int64(message.TotalSize.toString());
    }
    if (message.FileName !== undefined) {
      StringValue.encode({ value: message.FileName! }, writer.uint32(34).fork()).join();
    }
    if (message.ContentType !== undefined) {
      StringValue.encode({ value: message.ContentType! }, writer.uint32(42).fork()).join();
    }
    if (message.Path !== undefined) {
      StringValue.encode({ value: message.Path! }, writer.uint32(50).fork()).join();
    }
    if (message.IsSystemFile !== false) {
      writer.uint32(56).bool(message.IsSystemFile);
    }
    if (message.RepositoryId !== undefined) {
      StringValue.encode({ value: message.RepositoryId! }, writer.uint32(66).fork()).join();
    }
    if (message.FolderId !== undefined) {
      StringValue.encode({ value: message.FolderId! }, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FileChunk {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFileChunk();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Data = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.Offset = Long.fromString(reader.int64().toString());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.TotalSize = Long.fromString(reader.int64().toString());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.FileName = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ContentType = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.Path = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.IsSystemFile = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.RepositoryId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.FolderId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FileChunk {
    return {
      Data: isSet(object.Data) ? bytesFromBase64(object.Data) : new Uint8Array(0),
      Offset: isSet(object.Offset) ? Long.fromValue(object.Offset) : Long.ZERO,
      TotalSize: isSet(object.TotalSize) ? Long.fromValue(object.TotalSize) : Long.ZERO,
      FileName: isSet(object.FileName) ? String(object.FileName) : undefined,
      ContentType: isSet(object.ContentType) ? String(object.ContentType) : undefined,
      Path: isSet(object.Path) ? String(object.Path) : undefined,
      IsSystemFile: isSet(object.IsSystemFile) ? globalThis.Boolean(object.IsSystemFile) : false,
      RepositoryId: isSet(object.RepositoryId) ? String(object.RepositoryId) : undefined,
      FolderId: isSet(object.FolderId) ? String(object.FolderId) : undefined,
    };
  },

  toJSON(message: FileChunk): unknown {
    const obj: any = {};
    if (message.Data.length !== 0) {
      obj.Data = base64FromBytes(message.Data);
    }
    if (!message.Offset.equals(Long.ZERO)) {
      obj.Offset = (message.Offset || Long.ZERO).toString();
    }
    if (!message.TotalSize.equals(Long.ZERO)) {
      obj.TotalSize = (message.TotalSize || Long.ZERO).toString();
    }
    if (message.FileName !== undefined) {
      obj.FileName = message.FileName;
    }
    if (message.ContentType !== undefined) {
      obj.ContentType = message.ContentType;
    }
    if (message.Path !== undefined) {
      obj.Path = message.Path;
    }
    if (message.IsSystemFile !== false) {
      obj.IsSystemFile = message.IsSystemFile;
    }
    if (message.RepositoryId !== undefined) {
      obj.RepositoryId = message.RepositoryId;
    }
    if (message.FolderId !== undefined) {
      obj.FolderId = message.FolderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FileChunk>, I>>(base?: I): FileChunk {
    return FileChunk.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FileChunk>, I>>(object: I): FileChunk {
    const message = createBaseFileChunk();
    message.Data = object.Data ?? new Uint8Array(0);
    message.Offset = (object.Offset !== undefined && object.Offset !== null)
      ? Long.fromValue(object.Offset)
      : Long.ZERO;
    message.TotalSize = (object.TotalSize !== undefined && object.TotalSize !== null)
      ? Long.fromValue(object.TotalSize)
      : Long.ZERO;
    message.FileName = object.FileName ?? undefined;
    message.ContentType = object.ContentType ?? undefined;
    message.Path = object.Path ?? undefined;
    message.IsSystemFile = object.IsSystemFile ?? false;
    message.RepositoryId = object.RepositoryId ?? undefined;
    message.FolderId = object.FolderId ?? undefined;
    return message;
  },
};

function createBaseShardChunk(): ShardChunk {
  return { Data: new Uint8Array(0), ShardId: "", ShardIndex: 0, Offset: Long.ZERO, TotalSize: Long.ZERO };
}

export const ShardChunk: MessageFns<ShardChunk> = {
  encode(message: ShardChunk, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Data.length !== 0) {
      writer.uint32(10).bytes(message.Data);
    }
    if (message.ShardId !== "") {
      writer.uint32(18).string(message.ShardId);
    }
    if (message.ShardIndex !== 0) {
      writer.uint32(24).int32(message.ShardIndex);
    }
    if (!message.Offset.equals(Long.ZERO)) {
      writer.uint32(32).int64(message.Offset.toString());
    }
    if (!message.TotalSize.equals(Long.ZERO)) {
      writer.uint32(40).int64(message.TotalSize.toString());
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ShardChunk {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseShardChunk();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Data = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ShardId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.ShardIndex = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.Offset = Long.fromString(reader.int64().toString());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.TotalSize = Long.fromString(reader.int64().toString());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ShardChunk {
    return {
      Data: isSet(object.Data) ? bytesFromBase64(object.Data) : new Uint8Array(0),
      ShardId: isSet(object.ShardId) ? globalThis.String(object.ShardId) : "",
      ShardIndex: isSet(object.ShardIndex) ? globalThis.Number(object.ShardIndex) : 0,
      Offset: isSet(object.Offset) ? Long.fromValue(object.Offset) : Long.ZERO,
      TotalSize: isSet(object.TotalSize) ? Long.fromValue(object.TotalSize) : Long.ZERO,
    };
  },

  toJSON(message: ShardChunk): unknown {
    const obj: any = {};
    if (message.Data.length !== 0) {
      obj.Data = base64FromBytes(message.Data);
    }
    if (message.ShardId !== "") {
      obj.ShardId = message.ShardId;
    }
    if (message.ShardIndex !== 0) {
      obj.ShardIndex = Math.round(message.ShardIndex);
    }
    if (!message.Offset.equals(Long.ZERO)) {
      obj.Offset = (message.Offset || Long.ZERO).toString();
    }
    if (!message.TotalSize.equals(Long.ZERO)) {
      obj.TotalSize = (message.TotalSize || Long.ZERO).toString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ShardChunk>, I>>(base?: I): ShardChunk {
    return ShardChunk.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ShardChunk>, I>>(object: I): ShardChunk {
    const message = createBaseShardChunk();
    message.Data = object.Data ?? new Uint8Array(0);
    message.ShardId = object.ShardId ?? "";
    message.ShardIndex = object.ShardIndex ?? 0;
    message.Offset = (object.Offset !== undefined && object.Offset !== null)
      ? Long.fromValue(object.Offset)
      : Long.ZERO;
    message.TotalSize = (object.TotalSize !== undefined && object.TotalSize !== null)
      ? Long.fromValue(object.TotalSize)
      : Long.ZERO;
    return message;
  },
};

function createBaseUploadResponse(): UploadResponse {
  return { Success: false, File: undefined, Error: undefined };
}

export const UploadResponse: MessageFns<UploadResponse> = {
  encode(message: UploadResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.File !== undefined) {
      DriveFile.encode(message.File, writer.uint32(18).fork()).join();
    }
    if (message.Error !== undefined) {
      StringValue.encode({ value: message.Error! }, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.File = DriveFile.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Error = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      File: isSet(object.File) ? DriveFile.fromJSON(object.File) : undefined,
      Error: isSet(object.Error) ? String(object.Error) : undefined,
    };
  },

  toJSON(message: UploadResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.File !== undefined) {
      obj.File = DriveFile.toJSON(message.File);
    }
    if (message.Error !== undefined) {
      obj.Error = message.Error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadResponse>, I>>(base?: I): UploadResponse {
    return UploadResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadResponse>, I>>(object: I): UploadResponse {
    const message = createBaseUploadResponse();
    message.Success = object.Success ?? false;
    message.File = (object.File !== undefined && object.File !== null) ? DriveFile.fromPartial(object.File) : undefined;
    message.Error = object.Error ?? undefined;
    return message;
  },
};

function createBaseDownloadRequest(): DownloadRequest {
  return { FileId: "" };
}

export const DownloadRequest: MessageFns<DownloadRequest> = {
  encode(message: DownloadRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.FileId !== "") {
      writer.uint32(10).string(message.FileId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DownloadRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDownloadRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.FileId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DownloadRequest {
    return { FileId: isSet(object.FileId) ? globalThis.String(object.FileId) : "" };
  },

  toJSON(message: DownloadRequest): unknown {
    const obj: any = {};
    if (message.FileId !== "") {
      obj.FileId = message.FileId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DownloadRequest>, I>>(base?: I): DownloadRequest {
    return DownloadRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DownloadRequest>, I>>(object: I): DownloadRequest {
    const message = createBaseDownloadRequest();
    message.FileId = object.FileId ?? "";
    return message;
  },
};

function createBaseListFilesRequest(): ListFilesRequest {
  return {
    Path: undefined,
    SearchQuery: undefined,
    IncludeSystemFiles: false,
    PageSize: 0,
    ContinuationToken: undefined,
    RepositoryId: undefined,
    FolderId: undefined,
  };
}

export const ListFilesRequest: MessageFns<ListFilesRequest> = {
  encode(message: ListFilesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Path !== undefined) {
      StringValue.encode({ value: message.Path! }, writer.uint32(10).fork()).join();
    }
    if (message.SearchQuery !== undefined) {
      StringValue.encode({ value: message.SearchQuery! }, writer.uint32(18).fork()).join();
    }
    if (message.IncludeSystemFiles !== false) {
      writer.uint32(24).bool(message.IncludeSystemFiles);
    }
    if (message.PageSize !== 0) {
      writer.uint32(32).int32(message.PageSize);
    }
    if (message.ContinuationToken !== undefined) {
      StringValue.encode({ value: message.ContinuationToken! }, writer.uint32(42).fork()).join();
    }
    if (message.RepositoryId !== undefined) {
      StringValue.encode({ value: message.RepositoryId! }, writer.uint32(50).fork()).join();
    }
    if (message.FolderId !== undefined) {
      StringValue.encode({ value: message.FolderId! }, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListFilesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListFilesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Path = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.SearchQuery = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.IncludeSystemFiles = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.PageSize = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ContinuationToken = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.RepositoryId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.FolderId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListFilesRequest {
    return {
      Path: isSet(object.Path) ? String(object.Path) : undefined,
      SearchQuery: isSet(object.SearchQuery) ? String(object.SearchQuery) : undefined,
      IncludeSystemFiles: isSet(object.IncludeSystemFiles) ? globalThis.Boolean(object.IncludeSystemFiles) : false,
      PageSize: isSet(object.PageSize) ? globalThis.Number(object.PageSize) : 0,
      ContinuationToken: isSet(object.ContinuationToken) ? String(object.ContinuationToken) : undefined,
      RepositoryId: isSet(object.RepositoryId) ? String(object.RepositoryId) : undefined,
      FolderId: isSet(object.FolderId) ? String(object.FolderId) : undefined,
    };
  },

  toJSON(message: ListFilesRequest): unknown {
    const obj: any = {};
    if (message.Path !== undefined) {
      obj.Path = message.Path;
    }
    if (message.SearchQuery !== undefined) {
      obj.SearchQuery = message.SearchQuery;
    }
    if (message.IncludeSystemFiles !== false) {
      obj.IncludeSystemFiles = message.IncludeSystemFiles;
    }
    if (message.PageSize !== 0) {
      obj.PageSize = Math.round(message.PageSize);
    }
    if (message.ContinuationToken !== undefined) {
      obj.ContinuationToken = message.ContinuationToken;
    }
    if (message.RepositoryId !== undefined) {
      obj.RepositoryId = message.RepositoryId;
    }
    if (message.FolderId !== undefined) {
      obj.FolderId = message.FolderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListFilesRequest>, I>>(base?: I): ListFilesRequest {
    return ListFilesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListFilesRequest>, I>>(object: I): ListFilesRequest {
    const message = createBaseListFilesRequest();
    message.Path = object.Path ?? undefined;
    message.SearchQuery = object.SearchQuery ?? undefined;
    message.IncludeSystemFiles = object.IncludeSystemFiles ?? false;
    message.PageSize = object.PageSize ?? 0;
    message.ContinuationToken = object.ContinuationToken ?? undefined;
    message.RepositoryId = object.RepositoryId ?? undefined;
    message.FolderId = object.FolderId ?? undefined;
    return message;
  },
};

function createBaseListFilesResponse(): ListFilesResponse {
  return {
    Files: [],
    Folders: [],
    ContinuationToken: undefined,
    Limits: undefined,
    SubFolders: [],
    Repository: undefined,
  };
}

export const ListFilesResponse: MessageFns<ListFilesResponse> = {
  encode(message: ListFilesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Files) {
      DriveFile.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.Folders) {
      DriveFolder.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.ContinuationToken !== undefined) {
      StringValue.encode({ value: message.ContinuationToken! }, writer.uint32(26).fork()).join();
    }
    if (message.Limits !== undefined) {
      StorageLimits.encode(message.Limits, writer.uint32(34).fork()).join();
    }
    for (const v of message.SubFolders) {
      DriveFolderRecord.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.Repository !== undefined) {
      DriveRepository.encode(message.Repository, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListFilesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListFilesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Files.push(DriveFile.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Folders.push(DriveFolder.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ContinuationToken = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Limits = StorageLimits.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.SubFolders.push(DriveFolderRecord.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.Repository = DriveRepository.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListFilesResponse {
    return {
      Files: globalThis.Array.isArray(object?.Files) ? object.Files.map((e: any) => DriveFile.fromJSON(e)) : [],
      Folders: globalThis.Array.isArray(object?.Folders) ? object.Folders.map((e: any) => DriveFolder.fromJSON(e)) : [],
      ContinuationToken: isSet(object.ContinuationToken) ? String(object.ContinuationToken) : undefined,
      Limits: isSet(object.Limits) ? StorageLimits.fromJSON(object.Limits) : undefined,
      SubFolders: globalThis.Array.isArray(object?.SubFolders)
        ? object.SubFolders.map((e: any) => DriveFolderRecord.fromJSON(e))
        : [],
      Repository: isSet(object.Repository) ? DriveRepository.fromJSON(object.Repository) : undefined,
    };
  },

  toJSON(message: ListFilesResponse): unknown {
    const obj: any = {};
    if (message.Files?.length) {
      obj.Files = message.Files.map((e) => DriveFile.toJSON(e));
    }
    if (message.Folders?.length) {
      obj.Folders = message.Folders.map((e) => DriveFolder.toJSON(e));
    }
    if (message.ContinuationToken !== undefined) {
      obj.ContinuationToken = message.ContinuationToken;
    }
    if (message.Limits !== undefined) {
      obj.Limits = StorageLimits.toJSON(message.Limits);
    }
    if (message.SubFolders?.length) {
      obj.SubFolders = message.SubFolders.map((e) => DriveFolderRecord.toJSON(e));
    }
    if (message.Repository !== undefined) {
      obj.Repository = DriveRepository.toJSON(message.Repository);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListFilesResponse>, I>>(base?: I): ListFilesResponse {
    return ListFilesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListFilesResponse>, I>>(object: I): ListFilesResponse {
    const message = createBaseListFilesResponse();
    message.Files = object.Files?.map((e) => DriveFile.fromPartial(e)) || [];
    message.Folders = object.Folders?.map((e) => DriveFolder.fromPartial(e)) || [];
    message.ContinuationToken = object.ContinuationToken ?? undefined;
    message.Limits = (object.Limits !== undefined && object.Limits !== null)
      ? StorageLimits.fromPartial(object.Limits)
      : undefined;
    message.SubFolders = object.SubFolders?.map((e) => DriveFolderRecord.fromPartial(e)) || [];
    message.Repository = (object.Repository !== undefined && object.Repository !== null)
      ? DriveRepository.fromPartial(object.Repository)
      : undefined;
    return message;
  },
};

function createBaseDeleteFileRequest(): DeleteFileRequest {
  return { FileId: "" };
}

export const DeleteFileRequest: MessageFns<DeleteFileRequest> = {
  encode(message: DeleteFileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.FileId !== "") {
      writer.uint32(10).string(message.FileId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.FileId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFileRequest {
    return { FileId: isSet(object.FileId) ? globalThis.String(object.FileId) : "" };
  },

  toJSON(message: DeleteFileRequest): unknown {
    const obj: any = {};
    if (message.FileId !== "") {
      obj.FileId = message.FileId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFileRequest>, I>>(base?: I): DeleteFileRequest {
    return DeleteFileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFileRequest>, I>>(object: I): DeleteFileRequest {
    const message = createBaseDeleteFileRequest();
    message.FileId = object.FileId ?? "";
    return message;
  },
};

function createBaseDeleteFileResponse(): DeleteFileResponse {
  return { Success: false };
}

export const DeleteFileResponse: MessageFns<DeleteFileResponse> = {
  encode(message: DeleteFileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFileResponse {
    return { Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false };
  },

  toJSON(message: DeleteFileResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFileResponse>, I>>(base?: I): DeleteFileResponse {
    return DeleteFileResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFileResponse>, I>>(object: I): DeleteFileResponse {
    const message = createBaseDeleteFileResponse();
    message.Success = object.Success ?? false;
    return message;
  },
};

function createBaseVectorSearchRequest(): VectorSearchRequest {
  return { Query: "", TopK: 0, IncludeSystemFiles: false, FileIds: [], RepositoryIds: [] };
}

export const VectorSearchRequest: MessageFns<VectorSearchRequest> = {
  encode(message: VectorSearchRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Query !== "") {
      writer.uint32(10).string(message.Query);
    }
    if (message.TopK !== 0) {
      writer.uint32(16).int32(message.TopK);
    }
    if (message.IncludeSystemFiles !== false) {
      writer.uint32(24).bool(message.IncludeSystemFiles);
    }
    for (const v of message.FileIds) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.RepositoryIds) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VectorSearchRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVectorSearchRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Query = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.TopK = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.IncludeSystemFiles = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.FileIds.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.RepositoryIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VectorSearchRequest {
    return {
      Query: isSet(object.Query) ? globalThis.String(object.Query) : "",
      TopK: isSet(object.TopK) ? globalThis.Number(object.TopK) : 0,
      IncludeSystemFiles: isSet(object.IncludeSystemFiles) ? globalThis.Boolean(object.IncludeSystemFiles) : false,
      FileIds: globalThis.Array.isArray(object?.FileIds) ? object.FileIds.map((e: any) => globalThis.String(e)) : [],
      RepositoryIds: globalThis.Array.isArray(object?.RepositoryIds)
        ? object.RepositoryIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: VectorSearchRequest): unknown {
    const obj: any = {};
    if (message.Query !== "") {
      obj.Query = message.Query;
    }
    if (message.TopK !== 0) {
      obj.TopK = Math.round(message.TopK);
    }
    if (message.IncludeSystemFiles !== false) {
      obj.IncludeSystemFiles = message.IncludeSystemFiles;
    }
    if (message.FileIds?.length) {
      obj.FileIds = message.FileIds;
    }
    if (message.RepositoryIds?.length) {
      obj.RepositoryIds = message.RepositoryIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VectorSearchRequest>, I>>(base?: I): VectorSearchRequest {
    return VectorSearchRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VectorSearchRequest>, I>>(object: I): VectorSearchRequest {
    const message = createBaseVectorSearchRequest();
    message.Query = object.Query ?? "";
    message.TopK = object.TopK ?? 0;
    message.IncludeSystemFiles = object.IncludeSystemFiles ?? false;
    message.FileIds = object.FileIds?.map((e) => e) || [];
    message.RepositoryIds = object.RepositoryIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseVectorSearchResponse(): VectorSearchResponse {
  return { Results: [] };
}

export const VectorSearchResponse: MessageFns<VectorSearchResponse> = {
  encode(message: VectorSearchResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Results) {
      VectorSearchResult.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VectorSearchResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVectorSearchResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Results.push(VectorSearchResult.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VectorSearchResponse {
    return {
      Results: globalThis.Array.isArray(object?.Results)
        ? object.Results.map((e: any) => VectorSearchResult.fromJSON(e))
        : [],
    };
  },

  toJSON(message: VectorSearchResponse): unknown {
    const obj: any = {};
    if (message.Results?.length) {
      obj.Results = message.Results.map((e) => VectorSearchResult.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VectorSearchResponse>, I>>(base?: I): VectorSearchResponse {
    return VectorSearchResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VectorSearchResponse>, I>>(object: I): VectorSearchResponse {
    const message = createBaseVectorSearchResponse();
    message.Results = object.Results?.map((e) => VectorSearchResult.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFileSearchRequest(): FileSearchRequest {
  return { Query: "", MaxResults: 0, RepositoryIds: [] };
}

export const FileSearchRequest: MessageFns<FileSearchRequest> = {
  encode(message: FileSearchRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Query !== "") {
      writer.uint32(10).string(message.Query);
    }
    if (message.MaxResults !== 0) {
      writer.uint32(16).int32(message.MaxResults);
    }
    for (const v of message.RepositoryIds) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FileSearchRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFileSearchRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Query = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.MaxResults = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.RepositoryIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FileSearchRequest {
    return {
      Query: isSet(object.Query) ? globalThis.String(object.Query) : "",
      MaxResults: isSet(object.MaxResults) ? globalThis.Number(object.MaxResults) : 0,
      RepositoryIds: globalThis.Array.isArray(object?.RepositoryIds)
        ? object.RepositoryIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: FileSearchRequest): unknown {
    const obj: any = {};
    if (message.Query !== "") {
      obj.Query = message.Query;
    }
    if (message.MaxResults !== 0) {
      obj.MaxResults = Math.round(message.MaxResults);
    }
    if (message.RepositoryIds?.length) {
      obj.RepositoryIds = message.RepositoryIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FileSearchRequest>, I>>(base?: I): FileSearchRequest {
    return FileSearchRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FileSearchRequest>, I>>(object: I): FileSearchRequest {
    const message = createBaseFileSearchRequest();
    message.Query = object.Query ?? "";
    message.MaxResults = object.MaxResults ?? 0;
    message.RepositoryIds = object.RepositoryIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseFileSearchResponse(): FileSearchResponse {
  return { Files: [] };
}

export const FileSearchResponse: MessageFns<FileSearchResponse> = {
  encode(message: FileSearchResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Files) {
      DriveFile.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FileSearchResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFileSearchResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Files.push(DriveFile.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FileSearchResponse {
    return {
      Files: globalThis.Array.isArray(object?.Files) ? object.Files.map((e: any) => DriveFile.fromJSON(e)) : [],
    };
  },

  toJSON(message: FileSearchResponse): unknown {
    const obj: any = {};
    if (message.Files?.length) {
      obj.Files = message.Files.map((e) => DriveFile.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FileSearchResponse>, I>>(base?: I): FileSearchResponse {
    return FileSearchResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FileSearchResponse>, I>>(object: I): FileSearchResponse {
    const message = createBaseFileSearchResponse();
    message.Files = object.Files?.map((e) => DriveFile.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateRepositoryRequest(): CreateRepositoryRequest {
  return { Name: "" };
}

export const CreateRepositoryRequest: MessageFns<CreateRepositoryRequest> = {
  encode(message: CreateRepositoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Name !== "") {
      writer.uint32(10).string(message.Name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateRepositoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateRepositoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateRepositoryRequest {
    return { Name: isSet(object.Name) ? globalThis.String(object.Name) : "" };
  },

  toJSON(message: CreateRepositoryRequest): unknown {
    const obj: any = {};
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateRepositoryRequest>, I>>(base?: I): CreateRepositoryRequest {
    return CreateRepositoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateRepositoryRequest>, I>>(object: I): CreateRepositoryRequest {
    const message = createBaseCreateRepositoryRequest();
    message.Name = object.Name ?? "";
    return message;
  },
};

function createBaseCreateRepositoryResponse(): CreateRepositoryResponse {
  return { Success: false, Repository: undefined, Error: undefined };
}

export const CreateRepositoryResponse: MessageFns<CreateRepositoryResponse> = {
  encode(message: CreateRepositoryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Repository !== undefined) {
      DriveRepository.encode(message.Repository, writer.uint32(18).fork()).join();
    }
    if (message.Error !== undefined) {
      StringValue.encode({ value: message.Error! }, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateRepositoryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateRepositoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Repository = DriveRepository.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Error = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateRepositoryResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Repository: isSet(object.Repository) ? DriveRepository.fromJSON(object.Repository) : undefined,
      Error: isSet(object.Error) ? String(object.Error) : undefined,
    };
  },

  toJSON(message: CreateRepositoryResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Repository !== undefined) {
      obj.Repository = DriveRepository.toJSON(message.Repository);
    }
    if (message.Error !== undefined) {
      obj.Error = message.Error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateRepositoryResponse>, I>>(base?: I): CreateRepositoryResponse {
    return CreateRepositoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateRepositoryResponse>, I>>(object: I): CreateRepositoryResponse {
    const message = createBaseCreateRepositoryResponse();
    message.Success = object.Success ?? false;
    message.Repository = (object.Repository !== undefined && object.Repository !== null)
      ? DriveRepository.fromPartial(object.Repository)
      : undefined;
    message.Error = object.Error ?? undefined;
    return message;
  },
};

function createBaseListRepositoriesRequest(): ListRepositoriesRequest {
  return { IncludeTrash: false };
}

export const ListRepositoriesRequest: MessageFns<ListRepositoriesRequest> = {
  encode(message: ListRepositoriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.IncludeTrash !== false) {
      writer.uint32(8).bool(message.IncludeTrash);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListRepositoriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListRepositoriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.IncludeTrash = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListRepositoriesRequest {
    return { IncludeTrash: isSet(object.IncludeTrash) ? globalThis.Boolean(object.IncludeTrash) : false };
  },

  toJSON(message: ListRepositoriesRequest): unknown {
    const obj: any = {};
    if (message.IncludeTrash !== false) {
      obj.IncludeTrash = message.IncludeTrash;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListRepositoriesRequest>, I>>(base?: I): ListRepositoriesRequest {
    return ListRepositoriesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListRepositoriesRequest>, I>>(object: I): ListRepositoriesRequest {
    const message = createBaseListRepositoriesRequest();
    message.IncludeTrash = object.IncludeTrash ?? false;
    return message;
  },
};

function createBaseListRepositoriesResponse(): ListRepositoriesResponse {
  return { Repositories: [] };
}

export const ListRepositoriesResponse: MessageFns<ListRepositoriesResponse> = {
  encode(message: ListRepositoriesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Repositories) {
      DriveRepository.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListRepositoriesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListRepositoriesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Repositories.push(DriveRepository.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListRepositoriesResponse {
    return {
      Repositories: globalThis.Array.isArray(object?.Repositories)
        ? object.Repositories.map((e: any) => DriveRepository.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListRepositoriesResponse): unknown {
    const obj: any = {};
    if (message.Repositories?.length) {
      obj.Repositories = message.Repositories.map((e) => DriveRepository.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListRepositoriesResponse>, I>>(base?: I): ListRepositoriesResponse {
    return ListRepositoriesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListRepositoriesResponse>, I>>(object: I): ListRepositoriesResponse {
    const message = createBaseListRepositoriesResponse();
    message.Repositories = object.Repositories?.map((e) => DriveRepository.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDeleteRepositoryRequest(): DeleteRepositoryRequest {
  return { RepositoryId: "" };
}

export const DeleteRepositoryRequest: MessageFns<DeleteRepositoryRequest> = {
  encode(message: DeleteRepositoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.RepositoryId !== "") {
      writer.uint32(10).string(message.RepositoryId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteRepositoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteRepositoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.RepositoryId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteRepositoryRequest {
    return { RepositoryId: isSet(object.RepositoryId) ? globalThis.String(object.RepositoryId) : "" };
  },

  toJSON(message: DeleteRepositoryRequest): unknown {
    const obj: any = {};
    if (message.RepositoryId !== "") {
      obj.RepositoryId = message.RepositoryId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteRepositoryRequest>, I>>(base?: I): DeleteRepositoryRequest {
    return DeleteRepositoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteRepositoryRequest>, I>>(object: I): DeleteRepositoryRequest {
    const message = createBaseDeleteRepositoryRequest();
    message.RepositoryId = object.RepositoryId ?? "";
    return message;
  },
};

function createBaseDeleteRepositoryResponse(): DeleteRepositoryResponse {
  return { Success: false, Error: undefined };
}

export const DeleteRepositoryResponse: MessageFns<DeleteRepositoryResponse> = {
  encode(message: DeleteRepositoryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Error !== undefined) {
      StringValue.encode({ value: message.Error! }, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteRepositoryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteRepositoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Error = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteRepositoryResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Error: isSet(object.Error) ? String(object.Error) : undefined,
    };
  },

  toJSON(message: DeleteRepositoryResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Error !== undefined) {
      obj.Error = message.Error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteRepositoryResponse>, I>>(base?: I): DeleteRepositoryResponse {
    return DeleteRepositoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteRepositoryResponse>, I>>(object: I): DeleteRepositoryResponse {
    const message = createBaseDeleteRepositoryResponse();
    message.Success = object.Success ?? false;
    message.Error = object.Error ?? undefined;
    return message;
  },
};

function createBaseGrantRepositoryAccessRequest(): GrantRepositoryAccessRequest {
  return { RepositoryId: "", UserId: "", UserName: "", IsApp: false };
}

export const GrantRepositoryAccessRequest: MessageFns<GrantRepositoryAccessRequest> = {
  encode(message: GrantRepositoryAccessRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.RepositoryId !== "") {
      writer.uint32(10).string(message.RepositoryId);
    }
    if (message.UserId !== "") {
      writer.uint32(18).string(message.UserId);
    }
    if (message.UserName !== "") {
      writer.uint32(26).string(message.UserName);
    }
    if (message.IsApp !== false) {
      writer.uint32(32).bool(message.IsApp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GrantRepositoryAccessRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGrantRepositoryAccessRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.RepositoryId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.UserId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.UserName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.IsApp = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GrantRepositoryAccessRequest {
    return {
      RepositoryId: isSet(object.RepositoryId) ? globalThis.String(object.RepositoryId) : "",
      UserId: isSet(object.UserId) ? globalThis.String(object.UserId) : "",
      UserName: isSet(object.UserName) ? globalThis.String(object.UserName) : "",
      IsApp: isSet(object.IsApp) ? globalThis.Boolean(object.IsApp) : false,
    };
  },

  toJSON(message: GrantRepositoryAccessRequest): unknown {
    const obj: any = {};
    if (message.RepositoryId !== "") {
      obj.RepositoryId = message.RepositoryId;
    }
    if (message.UserId !== "") {
      obj.UserId = message.UserId;
    }
    if (message.UserName !== "") {
      obj.UserName = message.UserName;
    }
    if (message.IsApp !== false) {
      obj.IsApp = message.IsApp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GrantRepositoryAccessRequest>, I>>(base?: I): GrantRepositoryAccessRequest {
    return GrantRepositoryAccessRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GrantRepositoryAccessRequest>, I>>(object: I): GrantRepositoryAccessRequest {
    const message = createBaseGrantRepositoryAccessRequest();
    message.RepositoryId = object.RepositoryId ?? "";
    message.UserId = object.UserId ?? "";
    message.UserName = object.UserName ?? "";
    message.IsApp = object.IsApp ?? false;
    return message;
  },
};

function createBaseGrantRepositoryAccessResponse(): GrantRepositoryAccessResponse {
  return { Success: false, Error: undefined };
}

export const GrantRepositoryAccessResponse: MessageFns<GrantRepositoryAccessResponse> = {
  encode(message: GrantRepositoryAccessResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Error !== undefined) {
      StringValue.encode({ value: message.Error! }, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GrantRepositoryAccessResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGrantRepositoryAccessResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Error = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GrantRepositoryAccessResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Error: isSet(object.Error) ? String(object.Error) : undefined,
    };
  },

  toJSON(message: GrantRepositoryAccessResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Error !== undefined) {
      obj.Error = message.Error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GrantRepositoryAccessResponse>, I>>(base?: I): GrantRepositoryAccessResponse {
    return GrantRepositoryAccessResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GrantRepositoryAccessResponse>, I>>(
    object: I,
  ): GrantRepositoryAccessResponse {
    const message = createBaseGrantRepositoryAccessResponse();
    message.Success = object.Success ?? false;
    message.Error = object.Error ?? undefined;
    return message;
  },
};

function createBaseRevokeRepositoryAccessRequest(): RevokeRepositoryAccessRequest {
  return { RepositoryId: "", UserId: "" };
}

export const RevokeRepositoryAccessRequest: MessageFns<RevokeRepositoryAccessRequest> = {
  encode(message: RevokeRepositoryAccessRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.RepositoryId !== "") {
      writer.uint32(10).string(message.RepositoryId);
    }
    if (message.UserId !== "") {
      writer.uint32(18).string(message.UserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevokeRepositoryAccessRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRevokeRepositoryAccessRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.RepositoryId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.UserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RevokeRepositoryAccessRequest {
    return {
      RepositoryId: isSet(object.RepositoryId) ? globalThis.String(object.RepositoryId) : "",
      UserId: isSet(object.UserId) ? globalThis.String(object.UserId) : "",
    };
  },

  toJSON(message: RevokeRepositoryAccessRequest): unknown {
    const obj: any = {};
    if (message.RepositoryId !== "") {
      obj.RepositoryId = message.RepositoryId;
    }
    if (message.UserId !== "") {
      obj.UserId = message.UserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RevokeRepositoryAccessRequest>, I>>(base?: I): RevokeRepositoryAccessRequest {
    return RevokeRepositoryAccessRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RevokeRepositoryAccessRequest>, I>>(
    object: I,
  ): RevokeRepositoryAccessRequest {
    const message = createBaseRevokeRepositoryAccessRequest();
    message.RepositoryId = object.RepositoryId ?? "";
    message.UserId = object.UserId ?? "";
    return message;
  },
};

function createBaseRevokeRepositoryAccessResponse(): RevokeRepositoryAccessResponse {
  return { Success: false, Error: undefined };
}

export const RevokeRepositoryAccessResponse: MessageFns<RevokeRepositoryAccessResponse> = {
  encode(message: RevokeRepositoryAccessResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Error !== undefined) {
      StringValue.encode({ value: message.Error! }, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevokeRepositoryAccessResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRevokeRepositoryAccessResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Error = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RevokeRepositoryAccessResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Error: isSet(object.Error) ? String(object.Error) : undefined,
    };
  },

  toJSON(message: RevokeRepositoryAccessResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Error !== undefined) {
      obj.Error = message.Error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RevokeRepositoryAccessResponse>, I>>(base?: I): RevokeRepositoryAccessResponse {
    return RevokeRepositoryAccessResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RevokeRepositoryAccessResponse>, I>>(
    object: I,
  ): RevokeRepositoryAccessResponse {
    const message = createBaseRevokeRepositoryAccessResponse();
    message.Success = object.Success ?? false;
    message.Error = object.Error ?? undefined;
    return message;
  },
};

function createBaseCreateFolderRequest(): CreateFolderRequest {
  return { RepositoryId: "", Name: "", ParentFolderId: undefined };
}

export const CreateFolderRequest: MessageFns<CreateFolderRequest> = {
  encode(message: CreateFolderRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.RepositoryId !== "") {
      writer.uint32(10).string(message.RepositoryId);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    if (message.ParentFolderId !== undefined) {
      StringValue.encode({ value: message.ParentFolderId! }, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateFolderRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateFolderRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.RepositoryId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ParentFolderId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateFolderRequest {
    return {
      RepositoryId: isSet(object.RepositoryId) ? globalThis.String(object.RepositoryId) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      ParentFolderId: isSet(object.ParentFolderId) ? String(object.ParentFolderId) : undefined,
    };
  },

  toJSON(message: CreateFolderRequest): unknown {
    const obj: any = {};
    if (message.RepositoryId !== "") {
      obj.RepositoryId = message.RepositoryId;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.ParentFolderId !== undefined) {
      obj.ParentFolderId = message.ParentFolderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateFolderRequest>, I>>(base?: I): CreateFolderRequest {
    return CreateFolderRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateFolderRequest>, I>>(object: I): CreateFolderRequest {
    const message = createBaseCreateFolderRequest();
    message.RepositoryId = object.RepositoryId ?? "";
    message.Name = object.Name ?? "";
    message.ParentFolderId = object.ParentFolderId ?? undefined;
    return message;
  },
};

function createBaseCreateFolderResponse(): CreateFolderResponse {
  return { Success: false, Folder: undefined, Error: undefined };
}

export const CreateFolderResponse: MessageFns<CreateFolderResponse> = {
  encode(message: CreateFolderResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Folder !== undefined) {
      DriveFolderRecord.encode(message.Folder, writer.uint32(18).fork()).join();
    }
    if (message.Error !== undefined) {
      StringValue.encode({ value: message.Error! }, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateFolderResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateFolderResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Folder = DriveFolderRecord.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Error = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateFolderResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Folder: isSet(object.Folder) ? DriveFolderRecord.fromJSON(object.Folder) : undefined,
      Error: isSet(object.Error) ? String(object.Error) : undefined,
    };
  },

  toJSON(message: CreateFolderResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Folder !== undefined) {
      obj.Folder = DriveFolderRecord.toJSON(message.Folder);
    }
    if (message.Error !== undefined) {
      obj.Error = message.Error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateFolderResponse>, I>>(base?: I): CreateFolderResponse {
    return CreateFolderResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateFolderResponse>, I>>(object: I): CreateFolderResponse {
    const message = createBaseCreateFolderResponse();
    message.Success = object.Success ?? false;
    message.Folder = (object.Folder !== undefined && object.Folder !== null)
      ? DriveFolderRecord.fromPartial(object.Folder)
      : undefined;
    message.Error = object.Error ?? undefined;
    return message;
  },
};

function createBaseDeleteFolderRequest(): DeleteFolderRequest {
  return { FolderId: "" };
}

export const DeleteFolderRequest: MessageFns<DeleteFolderRequest> = {
  encode(message: DeleteFolderRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.FolderId !== "") {
      writer.uint32(10).string(message.FolderId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFolderRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFolderRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.FolderId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFolderRequest {
    return { FolderId: isSet(object.FolderId) ? globalThis.String(object.FolderId) : "" };
  },

  toJSON(message: DeleteFolderRequest): unknown {
    const obj: any = {};
    if (message.FolderId !== "") {
      obj.FolderId = message.FolderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFolderRequest>, I>>(base?: I): DeleteFolderRequest {
    return DeleteFolderRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFolderRequest>, I>>(object: I): DeleteFolderRequest {
    const message = createBaseDeleteFolderRequest();
    message.FolderId = object.FolderId ?? "";
    return message;
  },
};

function createBaseDeleteFolderResponse(): DeleteFolderResponse {
  return { Success: false, Error: undefined };
}

export const DeleteFolderResponse: MessageFns<DeleteFolderResponse> = {
  encode(message: DeleteFolderResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Error !== undefined) {
      StringValue.encode({ value: message.Error! }, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFolderResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFolderResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Error = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFolderResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Error: isSet(object.Error) ? String(object.Error) : undefined,
    };
  },

  toJSON(message: DeleteFolderResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Error !== undefined) {
      obj.Error = message.Error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFolderResponse>, I>>(base?: I): DeleteFolderResponse {
    return DeleteFolderResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFolderResponse>, I>>(object: I): DeleteFolderResponse {
    const message = createBaseDeleteFolderResponse();
    message.Success = object.Success ?? false;
    message.Error = object.Error ?? undefined;
    return message;
  },
};

function createBaseMoveFileRequest(): MoveFileRequest {
  return { FileId: "", TargetRepositoryId: "", TargetFolderId: undefined };
}

export const MoveFileRequest: MessageFns<MoveFileRequest> = {
  encode(message: MoveFileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.FileId !== "") {
      writer.uint32(10).string(message.FileId);
    }
    if (message.TargetRepositoryId !== "") {
      writer.uint32(18).string(message.TargetRepositoryId);
    }
    if (message.TargetFolderId !== undefined) {
      StringValue.encode({ value: message.TargetFolderId! }, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MoveFileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoveFileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.FileId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.TargetRepositoryId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.TargetFolderId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MoveFileRequest {
    return {
      FileId: isSet(object.FileId) ? globalThis.String(object.FileId) : "",
      TargetRepositoryId: isSet(object.TargetRepositoryId) ? globalThis.String(object.TargetRepositoryId) : "",
      TargetFolderId: isSet(object.TargetFolderId) ? String(object.TargetFolderId) : undefined,
    };
  },

  toJSON(message: MoveFileRequest): unknown {
    const obj: any = {};
    if (message.FileId !== "") {
      obj.FileId = message.FileId;
    }
    if (message.TargetRepositoryId !== "") {
      obj.TargetRepositoryId = message.TargetRepositoryId;
    }
    if (message.TargetFolderId !== undefined) {
      obj.TargetFolderId = message.TargetFolderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MoveFileRequest>, I>>(base?: I): MoveFileRequest {
    return MoveFileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MoveFileRequest>, I>>(object: I): MoveFileRequest {
    const message = createBaseMoveFileRequest();
    message.FileId = object.FileId ?? "";
    message.TargetRepositoryId = object.TargetRepositoryId ?? "";
    message.TargetFolderId = object.TargetFolderId ?? undefined;
    return message;
  },
};

function createBaseMoveFileResponse(): MoveFileResponse {
  return { Success: false, Error: undefined };
}

export const MoveFileResponse: MessageFns<MoveFileResponse> = {
  encode(message: MoveFileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Error !== undefined) {
      StringValue.encode({ value: message.Error! }, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MoveFileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoveFileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Error = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MoveFileResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Error: isSet(object.Error) ? String(object.Error) : undefined,
    };
  },

  toJSON(message: MoveFileResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Error !== undefined) {
      obj.Error = message.Error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MoveFileResponse>, I>>(base?: I): MoveFileResponse {
    return MoveFileResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MoveFileResponse>, I>>(object: I): MoveFileResponse {
    const message = createBaseMoveFileResponse();
    message.Success = object.Success ?? false;
    message.Error = object.Error ?? undefined;
    return message;
  },
};

function createBaseListTrashRequest(): ListTrashRequest {
  return { PageSize: 0 };
}

export const ListTrashRequest: MessageFns<ListTrashRequest> = {
  encode(message: ListTrashRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.PageSize !== 0) {
      writer.uint32(8).int32(message.PageSize);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListTrashRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListTrashRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.PageSize = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListTrashRequest {
    return { PageSize: isSet(object.PageSize) ? globalThis.Number(object.PageSize) : 0 };
  },

  toJSON(message: ListTrashRequest): unknown {
    const obj: any = {};
    if (message.PageSize !== 0) {
      obj.PageSize = Math.round(message.PageSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListTrashRequest>, I>>(base?: I): ListTrashRequest {
    return ListTrashRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListTrashRequest>, I>>(object: I): ListTrashRequest {
    const message = createBaseListTrashRequest();
    message.PageSize = object.PageSize ?? 0;
    return message;
  },
};

function createBaseListTrashResponse(): ListTrashResponse {
  return { Files: [] };
}

export const ListTrashResponse: MessageFns<ListTrashResponse> = {
  encode(message: ListTrashResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Files) {
      DriveFile.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListTrashResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListTrashResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Files.push(DriveFile.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListTrashResponse {
    return {
      Files: globalThis.Array.isArray(object?.Files) ? object.Files.map((e: any) => DriveFile.fromJSON(e)) : [],
    };
  },

  toJSON(message: ListTrashResponse): unknown {
    const obj: any = {};
    if (message.Files?.length) {
      obj.Files = message.Files.map((e) => DriveFile.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListTrashResponse>, I>>(base?: I): ListTrashResponse {
    return ListTrashResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListTrashResponse>, I>>(object: I): ListTrashResponse {
    const message = createBaseListTrashResponse();
    message.Files = object.Files?.map((e) => DriveFile.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRestoreFromTrashRequest(): RestoreFromTrashRequest {
  return { FileId: "" };
}

export const RestoreFromTrashRequest: MessageFns<RestoreFromTrashRequest> = {
  encode(message: RestoreFromTrashRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.FileId !== "") {
      writer.uint32(10).string(message.FileId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RestoreFromTrashRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRestoreFromTrashRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.FileId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RestoreFromTrashRequest {
    return { FileId: isSet(object.FileId) ? globalThis.String(object.FileId) : "" };
  },

  toJSON(message: RestoreFromTrashRequest): unknown {
    const obj: any = {};
    if (message.FileId !== "") {
      obj.FileId = message.FileId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RestoreFromTrashRequest>, I>>(base?: I): RestoreFromTrashRequest {
    return RestoreFromTrashRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RestoreFromTrashRequest>, I>>(object: I): RestoreFromTrashRequest {
    const message = createBaseRestoreFromTrashRequest();
    message.FileId = object.FileId ?? "";
    return message;
  },
};

function createBaseRestoreFromTrashResponse(): RestoreFromTrashResponse {
  return { Success: false, Error: undefined };
}

export const RestoreFromTrashResponse: MessageFns<RestoreFromTrashResponse> = {
  encode(message: RestoreFromTrashResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Error !== undefined) {
      StringValue.encode({ value: message.Error! }, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RestoreFromTrashResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRestoreFromTrashResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Error = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RestoreFromTrashResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Error: isSet(object.Error) ? String(object.Error) : undefined,
    };
  },

  toJSON(message: RestoreFromTrashResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Error !== undefined) {
      obj.Error = message.Error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RestoreFromTrashResponse>, I>>(base?: I): RestoreFromTrashResponse {
    return RestoreFromTrashResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RestoreFromTrashResponse>, I>>(object: I): RestoreFromTrashResponse {
    const message = createBaseRestoreFromTrashResponse();
    message.Success = object.Success ?? false;
    message.Error = object.Error ?? undefined;
    return message;
  },
};

function createBaseEmptyTrashRequest(): EmptyTrashRequest {
  return {};
}

export const EmptyTrashRequest: MessageFns<EmptyTrashRequest> = {
  encode(_: EmptyTrashRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmptyTrashRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmptyTrashRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): EmptyTrashRequest {
    return {};
  },

  toJSON(_: EmptyTrashRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<EmptyTrashRequest>, I>>(base?: I): EmptyTrashRequest {
    return EmptyTrashRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EmptyTrashRequest>, I>>(_: I): EmptyTrashRequest {
    const message = createBaseEmptyTrashRequest();
    return message;
  },
};

function createBaseEmptyTrashResponse(): EmptyTrashResponse {
  return { Success: false, DeletedCount: 0 };
}

export const EmptyTrashResponse: MessageFns<EmptyTrashResponse> = {
  encode(message: EmptyTrashResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.DeletedCount !== 0) {
      writer.uint32(16).int32(message.DeletedCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmptyTrashResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmptyTrashResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.DeletedCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EmptyTrashResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      DeletedCount: isSet(object.DeletedCount) ? globalThis.Number(object.DeletedCount) : 0,
    };
  },

  toJSON(message: EmptyTrashResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.DeletedCount !== 0) {
      obj.DeletedCount = Math.round(message.DeletedCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EmptyTrashResponse>, I>>(base?: I): EmptyTrashResponse {
    return EmptyTrashResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EmptyTrashResponse>, I>>(object: I): EmptyTrashResponse {
    const message = createBaseEmptyTrashResponse();
    message.Success = object.Success ?? false;
    message.DeletedCount = object.DeletedCount ?? 0;
    return message;
  },
};

function createBaseGetFilePreviewRequest(): GetFilePreviewRequest {
  return { FileId: "" };
}

export const GetFilePreviewRequest: MessageFns<GetFilePreviewRequest> = {
  encode(message: GetFilePreviewRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.FileId !== "") {
      writer.uint32(10).string(message.FileId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFilePreviewRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFilePreviewRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.FileId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFilePreviewRequest {
    return { FileId: isSet(object.FileId) ? globalThis.String(object.FileId) : "" };
  },

  toJSON(message: GetFilePreviewRequest): unknown {
    const obj: any = {};
    if (message.FileId !== "") {
      obj.FileId = message.FileId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFilePreviewRequest>, I>>(base?: I): GetFilePreviewRequest {
    return GetFilePreviewRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFilePreviewRequest>, I>>(object: I): GetFilePreviewRequest {
    const message = createBaseGetFilePreviewRequest();
    message.FileId = object.FileId ?? "";
    return message;
  },
};

function createBaseGetFilePreviewResponse(): GetFilePreviewResponse {
  return { PreviewHtml: "", PreviewContentType: "", RawBytes: new Uint8Array(0) };
}

export const GetFilePreviewResponse: MessageFns<GetFilePreviewResponse> = {
  encode(message: GetFilePreviewResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.PreviewHtml !== "") {
      writer.uint32(10).string(message.PreviewHtml);
    }
    if (message.PreviewContentType !== "") {
      writer.uint32(18).string(message.PreviewContentType);
    }
    if (message.RawBytes.length !== 0) {
      writer.uint32(26).bytes(message.RawBytes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFilePreviewResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFilePreviewResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.PreviewHtml = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.PreviewContentType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.RawBytes = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFilePreviewResponse {
    return {
      PreviewHtml: isSet(object.PreviewHtml) ? globalThis.String(object.PreviewHtml) : "",
      PreviewContentType: isSet(object.PreviewContentType) ? globalThis.String(object.PreviewContentType) : "",
      RawBytes: isSet(object.RawBytes) ? bytesFromBase64(object.RawBytes) : new Uint8Array(0),
    };
  },

  toJSON(message: GetFilePreviewResponse): unknown {
    const obj: any = {};
    if (message.PreviewHtml !== "") {
      obj.PreviewHtml = message.PreviewHtml;
    }
    if (message.PreviewContentType !== "") {
      obj.PreviewContentType = message.PreviewContentType;
    }
    if (message.RawBytes.length !== 0) {
      obj.RawBytes = base64FromBytes(message.RawBytes);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFilePreviewResponse>, I>>(base?: I): GetFilePreviewResponse {
    return GetFilePreviewResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFilePreviewResponse>, I>>(object: I): GetFilePreviewResponse {
    const message = createBaseGetFilePreviewResponse();
    message.PreviewHtml = object.PreviewHtml ?? "";
    message.PreviewContentType = object.PreviewContentType ?? "";
    message.RawBytes = object.RawBytes ?? new Uint8Array(0);
    return message;
  },
};

function createBaseGetAccountDriveSettingsRequest(): GetAccountDriveSettingsRequest {
  return {};
}

export const GetAccountDriveSettingsRequest: MessageFns<GetAccountDriveSettingsRequest> = {
  encode(_: GetAccountDriveSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAccountDriveSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAccountDriveSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetAccountDriveSettingsRequest {
    return {};
  },

  toJSON(_: GetAccountDriveSettingsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAccountDriveSettingsRequest>, I>>(base?: I): GetAccountDriveSettingsRequest {
    return GetAccountDriveSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAccountDriveSettingsRequest>, I>>(_: I): GetAccountDriveSettingsRequest {
    const message = createBaseGetAccountDriveSettingsRequest();
    return message;
  },
};

function createBaseGetAccountDriveSettingsResponse(): GetAccountDriveSettingsResponse {
  return { RestrictFolderCreationToManagers: false };
}

export const GetAccountDriveSettingsResponse: MessageFns<GetAccountDriveSettingsResponse> = {
  encode(message: GetAccountDriveSettingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.RestrictFolderCreationToManagers !== false) {
      writer.uint32(8).bool(message.RestrictFolderCreationToManagers);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAccountDriveSettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAccountDriveSettingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.RestrictFolderCreationToManagers = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAccountDriveSettingsResponse {
    return {
      RestrictFolderCreationToManagers: isSet(object.RestrictFolderCreationToManagers)
        ? globalThis.Boolean(object.RestrictFolderCreationToManagers)
        : false,
    };
  },

  toJSON(message: GetAccountDriveSettingsResponse): unknown {
    const obj: any = {};
    if (message.RestrictFolderCreationToManagers !== false) {
      obj.RestrictFolderCreationToManagers = message.RestrictFolderCreationToManagers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAccountDriveSettingsResponse>, I>>(base?: I): GetAccountDriveSettingsResponse {
    return GetAccountDriveSettingsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAccountDriveSettingsResponse>, I>>(
    object: I,
  ): GetAccountDriveSettingsResponse {
    const message = createBaseGetAccountDriveSettingsResponse();
    message.RestrictFolderCreationToManagers = object.RestrictFolderCreationToManagers ?? false;
    return message;
  },
};

function createBaseSetAccountDriveSettingsRequest(): SetAccountDriveSettingsRequest {
  return { RestrictFolderCreationToManagers: false };
}

export const SetAccountDriveSettingsRequest: MessageFns<SetAccountDriveSettingsRequest> = {
  encode(message: SetAccountDriveSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.RestrictFolderCreationToManagers !== false) {
      writer.uint32(8).bool(message.RestrictFolderCreationToManagers);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetAccountDriveSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetAccountDriveSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.RestrictFolderCreationToManagers = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetAccountDriveSettingsRequest {
    return {
      RestrictFolderCreationToManagers: isSet(object.RestrictFolderCreationToManagers)
        ? globalThis.Boolean(object.RestrictFolderCreationToManagers)
        : false,
    };
  },

  toJSON(message: SetAccountDriveSettingsRequest): unknown {
    const obj: any = {};
    if (message.RestrictFolderCreationToManagers !== false) {
      obj.RestrictFolderCreationToManagers = message.RestrictFolderCreationToManagers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetAccountDriveSettingsRequest>, I>>(base?: I): SetAccountDriveSettingsRequest {
    return SetAccountDriveSettingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetAccountDriveSettingsRequest>, I>>(
    object: I,
  ): SetAccountDriveSettingsRequest {
    const message = createBaseSetAccountDriveSettingsRequest();
    message.RestrictFolderCreationToManagers = object.RestrictFolderCreationToManagers ?? false;
    return message;
  },
};

function createBaseSetAccountDriveSettingsResponse(): SetAccountDriveSettingsResponse {
  return { Success: false };
}

export const SetAccountDriveSettingsResponse: MessageFns<SetAccountDriveSettingsResponse> = {
  encode(message: SetAccountDriveSettingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetAccountDriveSettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetAccountDriveSettingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetAccountDriveSettingsResponse {
    return { Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false };
  },

  toJSON(message: SetAccountDriveSettingsResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetAccountDriveSettingsResponse>, I>>(base?: I): SetAccountDriveSettingsResponse {
    return SetAccountDriveSettingsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetAccountDriveSettingsResponse>, I>>(
    object: I,
  ): SetAccountDriveSettingsResponse {
    const message = createBaseSetAccountDriveSettingsResponse();
    message.Success = object.Success ?? false;
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
